// Auto-generated by backend/generate_inline_i18n.py — fills 8 missing languages
// for inline translation objects. Keyed by Indonesian id text.
export const INLINE_I18N = {
 "10–13 Dzulhijjah": {
  "en": "10–13 Dhul Hijjah",
  "ar": "10–13 ذو الحجة",
  "fr": "10–13 Dhou al-Hijja",
  "de": "10–13 Dhul Hijja",
  "es": "10–13 Dhul Hijjah",
  "ru": "10–13 Зуль-Хиджа",
  "zh": "10–13 都尔·黑哲月",
  "ja": "10–13 ズルヒッジャ月",
  "ko": "10–13 줄히자",
  "hi": "10–13 ज़ुल-हिज्जा"
 },
 "7 Putaran": {
  "en": "7 Rounds",
  "ar": "7 أشواط",
  "fr": "7 Tours",
  "de": "7 Runden",
  "es": "7 Vueltas",
  "ru": "7 Кругов",
  "zh": "7 圈",
  "ja": "7 周",
  "ko": "7 바퀴",
  "hi": "7 चक्कर"
 },
 "9 Dzulhijjah": {
  "en": "9 Dhul Hijjah",
  "ar": "9 ذو الحجة",
  "fr": "9 Dhul Hijja",
  "de": "9. Dhul Hijja",
  "es": "9 Dhul Hijja",
  "ru": "9 Зуль-Хиджа",
  "zh": "12月9日（祝尔黑哲月）",
  "ja": "ズルヒッジャ月9日",
  "ko": "줄히자 9일",
  "hi": "9 ज़ुल हिज्जा"
 },
 "Adab & Doa Ziarah": {
  "en": "Etiquette & Supplications of Ziyarah",
  "ar": "آداب ودعاء الزيارة",
  "fr": "Étiquette & Invocations de la Ziyarah",
  "de": "Etikette & Bittgebete der Ziyarah",
  "es": "Etiqueta & Súplicas de la Ziyarah",
  "ru": "Этикет и Молитвы Зиярата",
  "zh": "探访礼仪与祈祷",
  "ja": "ズィヤーラのマナーと祈り",
  "ko": "지야라의 예절 및 기도",
  "hi": "ज़ियारह के आदाब और दुआएं"
 },
 "Adzan otomatis": {
  "en": "Automatic Adhan",
  "ar": "الأذان التلقائي",
  "fr": "Adhan automatique",
  "de": "Automatischer Adhan",
  "es": "Adhan automático",
  "ru": "Автоматический Азан",
  "zh": "自动唤礼",
  "ja": "自動アザーン",
  "ko": "자동 아잔",
  "hi": "स्वचालित अज़ान"
 },
 "Adzan otomatis saat waktu salat tiba": {
  "en": "Automatic adhan when prayer time arrives",
  "ar": "أذان تلقائي عند حلول وقت الصلاة",
  "fr": "Adhan automatique à l'heure de la prière",
  "de": "Automatischer Adhan bei Gebetszeit",
  "es": "Adhan automático cuando llega la hora de la oración",
  "ru": "Автоматический азан при наступлении времени намаза",
  "zh": "礼拜时间到时自动播放阿赞",
  "ja": "礼拝時間になると自動でアザーンが流れます",
  "ko": "예배 시간이 되면 자동으로 아잔이 울립니다",
  "hi": "नमाज़ का वक्त होने पर स्वचालित अज़ान"
 },
 "Adzan {prayer} berkumandang…": {
  "en": "The {prayer} adhan is resounding…",
  "ar": "أذان {prayer} يتردد صداه…",
  "fr": "L'adhan du {prayer} retentit…",
  "de": "Der Adhan des {prayer} erklingt…",
  "es": "El adhan del {prayer} resuena…",
  "ru": "Азан {prayer} звучит…",
  "zh": "{prayer}的阿赞响起……",
  "ja": "{prayer}のアザーンが響き渡る…",
  "ko": "{prayer} 아잔이 울려 퍼진다…",
  "hi": "{prayer} की अज़ान गूंज रही है…"
 },
 "Aktif": {
  "en": "Active",
  "ar": "نشط",
  "fr": "Actif",
  "de": "Aktiv",
  "es": "Activo",
  "ru": "Активный",
  "zh": "活跃",
  "ja": "アクティブ",
  "ko": "활성",
  "hi": "सक्रिय"
 },
 "Aktifkan Kompas": {
  "en": "Activate Compass",
  "ar": "تفعيل البوصلة",
  "fr": "Activer la boussole",
  "de": "Kompass aktivieren",
  "es": "Activar brújula",
  "ru": "Включить компас",
  "zh": "启用指南针",
  "ja": "コンパスを有効にする",
  "ko": "나침반 활성화",
  "hi": "कम्पास सक्रिय करें"
 },
 "Akurasi kompas rendah — gerakkan HP membentuk angka 8 untuk kalibrasi": {
  "en": "Low compass accuracy — move your phone in a figure-8 motion to calibrate",
  "ar": "دقة البوصلة منخفضة — حرِّك هاتفك على شكل رقم 8 لإجراء المعايرة",
  "fr": "Précision de la boussole faible — déplacez votre téléphone en formant un chiffre 8 pour le calibrer",
  "de": "Kompassgenauigkeit gering — bewegen Sie Ihr Handy in einer Acht-Bewegung zur Kalibrierung",
  "es": "Precisión de la brújula baja — mueva su teléfono en forma de 8 para calibrar",
  "ru": "Точность компаса низкая — переместите телефон движением в форме цифры 8 для калибровки",
  "zh": "指南针精度低——请将手机做\"8\"字形移动以进行校准",
  "ja": "コンパスの精度が低いです — 校正するためにスマートフォンを8の字に動かしてください",
  "ko": "나침반 정확도가 낮습니다 — 보정을 위해 휴대폰을 8자 모양으로 움직이세요",
  "hi": "कम्पास की सटीकता कम है — कैलिब्रेट करने के लिए अपने फ़ोन को 8 के आकार में घुमाएं"
 },
 "Alur Perjalanan Haji": {
  "en": "Hajj Journey Flow",
  "ar": "مسار رحلة الحج",
  "fr": "Déroulement du Voyage du Hajj",
  "de": "Ablauf der Hajj-Reise",
  "es": "Flujo del Viaje del Hajj",
  "ru": "Маршрут Паломничества Хадж",
  "zh": "朝觐旅程流程",
  "ja": "ハッジの旅の流れ",
  "ko": "하지 여정 흐름",
  "hi": "हज यात्रा प्रवाह"
 },
 "Alur Perjalanan Umrah": {
  "en": "Umrah Journey Flow",
  "ar": "مسار رحلة العمرة",
  "fr": "Déroulement du Voyage de la Omra",
  "de": "Ablauf der Umrah-Reise",
  "es": "Flujo del Viaje de la Umrah",
  "ru": "Маршрут Путешествия Умры",
  "zh": "小朝旅程流程",
  "ja": "ウムラ旅程の流れ",
  "ko": "우므라 여정 흐름",
  "hi": "उमराह यात्रा प्रवाह"
 },
 "Anda berada dekat situs bersejarah ini.": {
  "en": "You are near this historical site.",
  "ar": "أنتَ بالقرب من هذا الموقع التاريخي.",
  "fr": "Vous êtes près de ce site historique.",
  "de": "Sie befinden sich in der Nähe dieser historischen Stätte.",
  "es": "Usted está cerca de este sitio histórico.",
  "ru": "Вы находитесь рядом с этим историческим местом.",
  "zh": "您靠近这处历史遗址。",
  "ja": "あなたはこの歴史的な場所の近くにいます。",
  "ko": "당신은 이 역사적인 장소 근처에 있습니다.",
  "hi": "आप इस ऐतिहासिक स्थल के पास हैं।"
 },
 "Anda di sini": {
  "en": "You are here",
  "ar": "أنت هنا",
  "fr": "Vous êtes ici",
  "de": "Sie sind hier",
  "es": "Usted está aquí",
  "ru": "Вы здесь",
  "zh": "您在这里",
  "ja": "あなたはここにいます",
  "ko": "당신은 여기 있습니다",
  "hi": "आप यहाँ हैं"
 },
 "Arah HP": {
  "en": "HP Direction",
  "ar": "اتجاه الهاتف",
  "fr": "Direction du téléphone",
  "de": "HP-Richtung",
  "es": "Dirección del teléfono",
  "ru": "Направление телефона",
  "zh": "手机方向",
  "ja": "スマホの方向",
  "ko": "휴대폰 방향",
  "hi": "फ़ोन की दिशा"
 },
 "Arah HP (simulasi)": {
  "en": "HP Direction (Simulation)",
  "ar": "اتجاه الهاتف (محاكاة)",
  "fr": "Direction du téléphone (Simulation)",
  "de": "HP-Richtung (Simulation)",
  "es": "Dirección del teléfono (Simulación)",
  "ru": "Направление телефона (Симуляция)",
  "zh": "手机方向（模拟）",
  "ja": "スマートフォンの方向（シミュレーション）",
  "ko": "핸드폰 방향 (시뮬레이션)",
  "hi": "फ़ोन की दिशा (सिमुलेशन)"
 },
 "Arah Kiblat": {
  "en": "Qibla Direction",
  "ar": "اتجاه القبلة",
  "fr": "Direction de la Qibla",
  "de": "Qibla-Richtung",
  "es": "Dirección de la Qibla",
  "ru": "Направление Киблы",
  "zh": "朝拜方向",
  "ja": "キブラの方向",
  "ko": "키블라 방향",
  "hi": "क़िब्ला दिशा"
 },
 "Arah kiblat": {
  "en": "Qibla direction",
  "ar": "اتجاه القبلة",
  "fr": "Direction de la Qibla",
  "de": "Qibla-Richtung",
  "es": "Dirección de la Qibla",
  "ru": "Направление Киблы",
  "zh": "朝拜方向",
  "ja": "キブラの方向",
  "ko": "키블라 방향",
  "hi": "क़िब्ला दिशा"
 },
 "Arahkan puncak HP ke arah panah untuk menghadap Kiblat": {
  "en": "Point the top of your phone towards the arrow to face the Qibla",
  "ar": "وجّه قمة الهاتف نحو السهم لاستقبال القبلة",
  "fr": "Pointez le haut de votre téléphone vers la flèche pour faire face à la Qibla",
  "de": "Richten Sie die Spitze Ihres Handys auf den Pfeil, um zur Qibla zu zeigen",
  "es": "Apunte la parte superior de su teléfono hacia la flecha para orientarse hacia la Qibla",
  "ru": "Направьте верхнюю часть телефона на стрелку, чтобы повернуться к Кибле",
  "zh": "将手机顶部对准箭头以朝向克尔白方向",
  "ja": "スマートフォンの上部を矢印の方向に向けてキブラの方角を確認してください",
  "ko": "휴대폰 상단을 화살표 방향으로 향하게 하여 키블라를 향하세요",
  "hi": "क़िबला की दिशा में मुंह करने के लिए अपने फोन की ऊपरी भाग को तीर की ओर इंगित करें"
 },
 "Audio kisah & doa yang tersimpan untuk didengar tanpa sinyal": {
  "en": "Saved audio stories & prayers to listen to without signal",
  "ar": "قصص صوتية وأدعية محفوظة للاستماع إليها بدون إنترنت",
  "fr": "Histoires audio et invocations sauvegardées à écouter sans connexion",
  "de": "Gespeicherte Audio-Geschichten & Gebete zum Anhören ohne Signal",
  "es": "Historias de audio y súplicas guardadas para escuchar sin señal",
  "ru": "Сохранённые аудио-истории и молитвы для прослушивания без сигнала",
  "zh": "已保存的音频故事和祈祷，无需信号即可收听",
  "ja": "電波なしで聴けるように保存された音声ストーリーとドゥアー",
  "ko": "신호 없이 들을 수 있도록 저장된 오디오 이야기 및 기도",
  "hi": "बिना सिग्नल के सुनने के लिए सहेजी गई ऑडियो कहानियाँ और दुआएँ"
 },
 "Audio kisah disimpan untuk offline": {
  "en": "Audio story saved for offline",
  "ar": "تم حفظ الصوت للاستخدام دون اتصال",
  "fr": "Audio de l'histoire enregistré pour une utilisation hors ligne",
  "de": "Audio-Geschichte für den Offline-Zugriff gespeichert",
  "es": "Audio de la historia guardado para uso sin conexión",
  "ru": "Аудио история сохранена для использования в автономном режиме",
  "zh": "故事音频已保存以供离线使用",
  "ja": "ストーリーの音声がオフライン用に保存されました",
  "ko": "스토리 오디오가 오프라인용으로 저장되었습니다",
  "hi": "कहानी का ऑडियो ऑफलाइन के लिए सहेजा गया"
 },
 "Audio tidak ditemukan": {
  "en": "Audio not found",
  "ar": "الصوت غير موجود",
  "fr": "Audio introuvable",
  "de": "Audio nicht gefunden",
  "es": "Audio no encontrado",
  "ru": "Аудио не найдено",
  "zh": "未找到音频",
  "ja": "音声が見つかりません",
  "ko": "오디오를 찾을 수 없습니다",
  "hi": "ऑडियो नहीं मिला"
 },
 "Ayyamul Bidh (13–15 Hijriah)": {
  "en": "Ayyamul Bidh (13–15 Hijri)",
  "ar": "أيام البيض (13–15 هجرية)",
  "fr": "Ayyamul Bidh (13–15 de l'Hégire)",
  "de": "Ayyamul Bidh (13.–15. Hijri)",
  "es": "Ayyamul Bidh (13–15 Hijri)",
  "ru": "Айямуль Бид (13–15 хиджры)",
  "zh": "白色斋戒日（伊历13–15日）",
  "ja": "アイヤームル・ビード（ヒジュラ暦13〜15日）",
  "ko": "아이야물 비드 (히즈라력 13–15일)",
  "hi": "अय्यामुल बीद (13–15 हिजरी)"
 },
 "Badai petir": {
  "en": "Thunderstorm",
  "ar": "عاصفة رعدية",
  "fr": "Orage",
  "de": "Gewitter",
  "es": "Tormenta eléctrica",
  "ru": "Гроза",
  "zh": "雷暴",
  "ja": "雷雨",
  "ko": "뇌우",
  "hi": "तड़ित झंझा"
 },
 "Bagikan": {
  "en": "Share",
  "ar": "مشاركة",
  "fr": "Partager",
  "de": "Teilen",
  "es": "Compartir",
  "ru": "Поделиться",
  "zh": "分享",
  "ja": "シェア",
  "ko": "공유",
  "hi": "साझा करें"
 },
 "Bagikan Pencapaian": {
  "en": "Share Achievement",
  "ar": "مشاركة الإنجاز",
  "fr": "Partager la Réussite",
  "de": "Erfolg teilen",
  "es": "Compartir Logro",
  "ru": "Поделиться Достижением",
  "zh": "分享成就",
  "ja": "達成を共有する",
  "ko": "성취 공유하기",
  "hi": "उपलब्धि साझा करें"
 },
 "Bagikan ke Keluarga": {
  "en": "Share with Family",
  "ar": "شارك مع العائلة",
  "fr": "Partager avec la famille",
  "de": "Mit Familie teilen",
  "es": "Compartir con la familia",
  "ru": "Поделиться с семьёй",
  "zh": "与家人分享",
  "ja": "家族とシェア",
  "ko": "가족과 공유",
  "hi": "परिवार के साथ साझा करें"
 },
 "Bahaya panas ekstrem": {
  "en": "Dangers of Extreme Heat",
  "ar": "مخاطر الحرارة الشديدة",
  "fr": "Dangers de la chaleur extrême",
  "de": "Gefahren extremer Hitze",
  "es": "Peligros del calor extremo",
  "ru": "Опасности экстремальной жары",
  "zh": "极端高温的危险",
  "ja": "極度の熱の危険性",
  "ko": "극심한 더위의 위험",
  "hi": "अत्यधिक गर्मी के खतरे"
 },
 "Batas & Niat": {
  "en": "Boundary & Intention",
  "ar": "الحد والنية",
  "fr": "Limite & Intention",
  "de": "Grenze & Absicht",
  "es": "Límite e Intención",
  "ru": "Граница и Намерение",
  "zh": "界限与意图",
  "ja": "境界と意図",
  "ko": "경계 및 의도",
  "hi": "सीमा और नियत"
 },
 "Bawa jadwal ini ke Tanah Suci — cetak atau simpan sebagai PDF. Waktu mengikuti lokasi, metode, dan zona waktu di atas.": {
  "en": "Take this schedule to the Holy Land — print or save as PDF. Times follow the location, method, and time zone above.",
  "ar": "خذ هذا الجدول إلى الأراضي المقدسة — اطبعه أو احفظه بصيغة PDF. الأوقات تتبع الموقع والطريقة والمنطقة الزمنية المذكورة أعلاه.",
  "fr": "Emportez ce programme en Terre Sainte — imprimez-le ou enregistrez-le en PDF. Les horaires suivent le lieu, la méthode et le fuseau horaire indiqués ci-dessus.",
  "de": "Nehmen Sie diesen Zeitplan ins Heilige Land — drucken Sie ihn aus oder speichern Sie ihn als PDF. Die Zeiten richten sich nach dem oben angegebenen Ort, der Methode und der Zeitzone.",
  "es": "Lleva este horario a la Tierra Santa — imprímelo o guárdalo como PDF. Los tiempos siguen la ubicación, el método y la zona horaria indicados arriba.",
  "ru": "Возьмите это расписание на Святую Землю — распечатайте или сохраните в формате PDF. Время соответствует местоположению, методу и часовому поясу, указанным выше.",
  "zh": "将此时间表带往圣地——打印或保存为PDF。时间依照上述地点、方法和时区。",
  "ja": "このスケジュールを聖地にお持ちください — 印刷するかPDFとして保存してください。時刻は上記の場所、方法、タイムゾーンに従います。",
  "ko": "이 일정표를 성지로 가져가세요 — 인쇄하거나 PDF로 저장하세요. 시간은 위의 위치, 방법 및 시간대를 따릅니다.",
  "hi": "इस समय-सारणी को पवित्र भूमि पर ले जाएं — इसे प्रिंट करें या PDF के रूप में सहेजें। समय ऊपर दिए गए स्थान, विधि और समय क्षेत्र के अनुसार है।"
 },
 "Belum ada audio tersimpan. Simpan kisah ziyarah atau doa untuk didengar offline.": {
  "en": "No audio saved yet. Save a ziyarah story or prayer to listen offline.",
  "ar": "لا يوجد صوت محفوظ بعد. احفظ قصة زيارة أو دعاءً للاستماع إليه دون اتصال.",
  "fr": "Aucun audio enregistré pour l'instant. Enregistrez une histoire de ziyarah ou une invocation pour l'écouter hors ligne.",
  "de": "Noch kein Audio gespeichert. Speichern Sie eine Ziyarah-Geschichte oder ein Gebet zum Offline-Anhören.",
  "es": "Aún no hay audio guardado. Guarda una historia de ziyarah o una oración para escuchar sin conexión.",
  "ru": "Аудио ещё не сохранено. Сохраните рассказ о зияре или дуа для прослушивания офлайн.",
  "zh": "尚未保存任何音频。保存一个探访故事或祈祷，以便离线收听。",
  "ja": "まだ保存されたオーディオはありません。ジヤーラの物語やドゥアーを保存してオフラインで聴きましょう。",
  "ko": "저장된 오디오가 없습니다. 지야라 이야기나 두아를 저장하여 오프라인으로 들으세요.",
  "hi": "अभी तक कोई ऑडियो सहेजा नहीं गया। ज़ियारत की कहानी या दुआ सहेजें और ऑफलाइन सुनें।"
 },
 "Belum ada catatan jurnal untuk diekspor.": {
  "en": "There are no journal entries to export yet.",
  "ar": "لا توجد إدخالات يومية للتصدير حتى الآن.",
  "fr": "Il n'y a pas encore d'entrées de journal à exporter.",
  "de": "Es sind noch keine Tagebucheinträge zum Exportieren vorhanden.",
  "es": "Aún no hay entradas de diario para exportar.",
  "ru": "Записей в журнале для экспорта пока нет.",
  "zh": "暂无可导出的日记条目。",
  "ja": "エクスポートするジャーナルエントリがまだありません。",
  "ko": "내보낼 일지 항목이 아직 없습니다.",
  "hi": "अभी तक निर्यात करने के लिए कोई जर्नल प्रविष्टि नहीं है।"
 },
 "Belum ada catatan. Mulai tulis kenangan ziarah Anda.": {
  "en": "No records yet. Start writing your pilgrimage memories.",
  "ar": "لا توجد سجلات بعد. ابدأ في كتابة ذكريات زيارتك.",
  "fr": "Aucun enregistrement pour l'instant. Commencez à écrire vos souvenirs de pèlerinage.",
  "de": "Noch keine Einträge. Beginnen Sie, Ihre Pilgererinnerungen aufzuschreiben.",
  "es": "Aún no hay registros. Comienza a escribir tus memorias de peregrinación.",
  "ru": "Записей пока нет. Начните записывать воспоминания о своём паломничестве.",
  "zh": "暂无记录。开始书写您的朝圣回忆吧。",
  "ja": "記録はまだありません。巡礼の思い出を書き始めましょう。",
  "ko": "아직 기록이 없습니다. 순례 추억을 작성해 보세요.",
  "hi": "अभी तक कोई रिकॉर्ड नहीं है। अपनी ज़ियारत की यादें लिखना शुरू करें।"
 },
 "Belum ada situs yang ditandai dikunjungi.": {
  "en": "No sites have been marked as visited yet.",
  "ar": "لم يتم تحديد أي مواقع كمُزارة بعد.",
  "fr": "Aucun site n'a encore été marqué comme visité.",
  "de": "Es wurden noch keine Stätten als besucht markiert.",
  "es": "Aún no se ha marcado ningún sitio como visitado.",
  "ru": "Ни одно место ещё не отмечено как посещённое.",
  "zh": "尚未标记任何已访问的地点。",
  "ja": "まだ訪問済みとしてマークされたスポットはありません。",
  "ko": "아직 방문한 것으로 표시된 장소가 없습니다.",
  "hi": "अभी तक कोई भी स्थल विज़िट किया हुआ चिह्नित नहीं किया गया है।"
 },
 "Belum aktif — tekan Mulai, atau nyalakan Otomatis untuk mulai sendiri saat sangat panas.": {
  "en": "Not active — press Start, or turn on Auto to begin automatically when it gets very hot.",
  "ar": "غير نشط — اضغط على بدء، أو شغّل الوضع التلقائي لبدء التشغيل تلقائياً عند الحر الشديد.",
  "fr": "Non actif — appuyez sur Démarrer, ou activez le mode Auto pour démarrer automatiquement quand il fait très chaud.",
  "de": "Nicht aktiv — drücken Sie Start, oder aktivieren Sie Auto, um automatisch zu starten, wenn es sehr heiß ist.",
  "es": "No activo — pulse Iniciar, o active el modo Auto para iniciarse automáticamente cuando haga mucho calor.",
  "ru": "Не активен — нажмите Пуск или включите режим Авто, чтобы он запускался автоматически при сильной жаре.",
  "zh": "未激活 — 按下\"开始\"，或开启\"自动\"模式，以在非常炎热时自动启动。",
  "ja": "非アクティブ — 「開始」を押すか、「自動」をオンにすると、非常に暑いときに自動で起動します。",
  "ko": "비활성 상태 — 시작을 누르거나, 자동 모드를 켜면 매우 더울 때 자동으로 시작됩니다.",
  "hi": "सक्रिय नहीं — प्रारंभ दबाएं, या स्वचालित चालू करें ताकि बहुत गर्मी होने पर यह अपने आप शुरू हो जाए।"
 },
 "Berawan sebagian": {
  "en": "Partly cloudy",
  "ar": "غائم جزئياً",
  "fr": "Partiellement nuageux",
  "de": "Teilweise bewölkt",
  "es": "Parcialmente nublado",
  "ru": "Переменная облачность",
  "zh": "局部多云",
  "ja": "一部曇り",
  "ko": "부분적으로 흐림",
  "hi": "आंशिक रूप से बादल छाए"
 },
 "Berdiri berdoa dan bertobat dari tergelincir matahari hingga terbenam — puncak dan rukun terbesar haji.": {
  "en": "Standing in prayer and repentance from the sun's decline until sunset — the peak and greatest pillar of Hajj.",
  "ar": "الوقوف بالدعاء والتوبة من زوال الشمس حتى غروبها — ذروة الحج وركنه الأعظم.",
  "fr": "Se tenir en prière et en repentir du déclin du soleil jusqu'à son coucher — le sommet et le plus grand pilier du Hajj.",
  "de": "Im Gebet und in der Reue stehen vom Sonnenstand bis zum Sonnenuntergang — der Höhepunkt und größte Pfeiler der Hajj.",
  "es": "Permanecer en oración y arrepentimiento desde el declive del sol hasta su puesta — la cúspide y el mayor pilar del Hajj.",
  "ru": "Стояние в молитве и покаянии от полудня до захода солнца — вершина и величайший столп хаджа.",
  "zh": "从日偏西至日落，站立祈祷与悔罪——朝觐的顶峰与最大支柱。",
  "ja": "日の傾きから日没まで、祈りと悔悟のうちに立つ——ハッジの頂点にして最大の柱。",
  "ko": "태양이 기울 때부터 일몰까지 기도와 회개로 서 있음 — 하지의 정점이자 가장 위대한 기둥.",
  "hi": "सूर्य के ढलने से सूर्यास्त तक प्रार्थना और पश्चाताप में खड़े रहना — हज का शिखर और सबसे महान स्तंभ।"
 },
 "Berjalan tujuh kali antara Safa dan Marwah, mengenang perjuangan Siti Hajar mencari air.": {
  "en": "Walking seven times between Safa and Marwah, commemorating the struggle of Hajar in search of water.",
  "ar": "السير سبع مرات بين الصفا والمروة، إحياءً لذكرى نضال السيدة هاجر في البحث عن الماء.",
  "fr": "Marcher sept fois entre Safa et Marwah, en commémorant la lutte de Hajar à la recherche d'eau.",
  "de": "Siebenmaliges Gehen zwischen Safa und Marwah, zum Gedenken an den Kampf von Hajar auf der Suche nach Wasser.",
  "es": "Caminar siete veces entre Safa y Marwah, conmemorando la lucha de Hajar en busca de agua.",
  "ru": "Семикратная ходьба между Сафой и Марвой в память о борьбе Хаджар в поисках воды.",
  "zh": "在萨法与麦尔卧之间往返七次，以纪念哈哲尔寻找水源的艰辛历程。",
  "ja": "サファーとマルワーの間を七回歩き、水を求めたハーイジャルの苦労を偲ぶ。",
  "ko": "사파와 마르와 사이를 일곱 번 걷으며, 물을 찾아 헤맨 하자르의 헌신을 기념합니다.",
  "hi": "सफ़ा और मरवा के बीच सात बार चलना, पानी की तलाश में हाजर के संघर्ष की याद में।"
 },
 "Berkabut": {
  "en": "Foggy",
  "ar": "ضبابي",
  "fr": "Brumeux",
  "de": "Neblig",
  "es": "Neblinoso",
  "ru": "Туманно",
  "zh": "有雾",
  "ja": "霧がかかっている",
  "ko": "안개 낀",
  "hi": "कोहरेदार"
 },
 "Bermalam di Muzdalifah — Panduan Haji Animasi": {
  "en": "Overnight Stay in Muzdalifah — Animated Hajj Guide",
  "ar": "المبيت في المزدلفة — دليل الحج المتحرك",
  "fr": "Nuit à Muzdalifah — Guide du Hajj Animé",
  "de": "Übernachtung in Muzdalifa — Animierter Hajj-Führer",
  "es": "Pernoctar en Muzdalifah — Guía Animada del Hajj",
  "ru": "Ночёвка в Муздалифе — Анимированный путеводитель по Хаджу",
  "zh": "在穆兹达利法过夜 — 动画朝觐指南",
  "ja": "ムズダリファでの夜明かし — アニメーションによるハッジガイド",
  "ko": "무즈달리파에서의 야영 — 애니메이션 하지 가이드",
  "hi": "मुज़्दलिफ़ा में रात्रि विश्राम — एनिमेटेड हज मार्गदर्शिका"
 },
 "Browser memblokir putar otomatis — ketuk untuk memutar adzan": {
  "en": "Browser blocked autoplay — tap to play the adhan",
  "ar": "المتصفح منع التشغيل التلقائي — اضغط لتشغيل الأذان",
  "fr": "Le navigateur a bloqué la lecture automatique — appuyez pour lire l'adhan",
  "de": "Browser hat automatische Wiedergabe blockiert — tippen, um den Adhan abzuspielen",
  "es": "El navegador bloqueó la reproducción automática — toca para reproducir el adhan",
  "ru": "Браузер заблокировал автовоспроизведение — нажмите, чтобы воспроизвести азан",
  "zh": "浏览器阻止了自动播放 — 点击以播放呼礼",
  "ja": "ブラウザが自動再生をブロックしました — アザーンを再生するにはタップしてください",
  "ko": "브라우저가 자동 재생을 차단했습니다 — 아잔을 재생하려면 탭하세요",
  "hi": "ब्राउज़र ने ऑटोप्ले ब्लॉक किया — अज़ान चलाने के लिए टैप करें"
 },
 "Buka WhatsApp": {
  "en": "Open WhatsApp",
  "ar": "افتح واتساب",
  "fr": "Ouvrir WhatsApp",
  "de": "WhatsApp öffnen",
  "es": "Abrir WhatsApp",
  "ru": "Открыть WhatsApp",
  "zh": "打开WhatsApp",
  "ja": "WhatsAppを開く",
  "ko": "WhatsApp 열기",
  "hi": "WhatsApp खोलें"
 },
 "Buka di Panduan": {
  "id": "Buka di Panduan",
  "en": "Open in Guide",
  "ar": "افتح في الدليل",
  "fr": "Ouvrir dans le guide",
  "de": "Im Leitfaden öffnen",
  "es": "Abrir en la guía",
  "ru": "Открыть в руководстве",
  "zh": "在指南中打开",
  "ja": "ガイドで開く",
  "ko": "가이드에서 열기",
  "hi": "गाइड में खोलें"
 },
 "Buka kompas kiblat": {
  "en": "Open the Qibla compass",
  "ar": "افتح بوصلة القبلة",
  "fr": "Ouvrir la boussole de la Qibla",
  "de": "Qibla-Kompass öffnen",
  "es": "Abrir la brújula de la Qibla",
  "ru": "Открыть компас киблы",
  "zh": "打开朝拜方向指南针",
  "ja": "キブラコンパスを開く",
  "ko": "키블라 나침반 열기",
  "hi": "क़िबला कम्पास खोलें"
 },
 "Cara Berhaji — Panduan Animasi 3 Menit": {
  "en": "How to Perform Hajj — A 3-Minute Animated Guide",
  "ar": "كيفية أداء الحج — دليل مصوّر بالرسوم المتحركة في 3 دقائق",
  "fr": "Comment accomplir le Hajj — Un guide animé de 3 minutes",
  "de": "Wie man die Hajj durchführt — Ein 3-minütiger Animationsführer",
  "es": "Cómo realizar el Hajj — Una guía animada de 3 minutos",
  "ru": "Как совершить Хадж — Анимированное руководство за 3 минуты",
  "zh": "如何朝觐 — 3分钟动画指南",
  "ja": "ハッジの行い方 — 3分間のアニメーションガイド",
  "ko": "하지 수행 방법 — 3분 애니메이션 가이드",
  "hi": "हज कैसे करें — 3 मिनट की एनिमेटेड गाइड"
 },
 "Catatan pribadi": {
  "en": "Personal notes",
  "ar": "ملاحظات شخصية",
  "fr": "Notes personnelles",
  "de": "Persönliche Notizen",
  "es": "Notas personales",
  "ru": "Личные заметки",
  "zh": "个人笔记",
  "ja": "個人メモ",
  "ko": "개인 메모",
  "hi": "व्यक्तिगत नोट्स"
 },
 "Cerah": {
  "en": "Sunny",
  "ar": "مشمس",
  "fr": "Ensoleillé",
  "de": "Sonnig",
  "es": "Soleado",
  "ru": "Солнечно",
  "zh": "晴天",
  "ja": "晴れ",
  "ko": "맑음",
  "hi": "धूप"
 },
 "Cerah berawan": {
  "en": "Partly cloudy",
  "ar": "غائم جزئياً",
  "fr": "Partiellement nuageux",
  "de": "Teilweise bewölkt",
  "es": "Parcialmente nublado",
  "ru": "Переменная облачность",
  "zh": "多云转晴",
  "ja": "晴れ時々曇り",
  "ko": "구름 조금",
  "hi": "आंशिक रूप से बादल छाए"
 },
 "Cetak": {
  "en": "Print",
  "ar": "طباعة",
  "fr": "Imprimer",
  "de": "Drucken",
  "es": "Imprimir",
  "ru": "Печать",
  "zh": "打印",
  "ja": "印刷",
  "ko": "인쇄",
  "hi": "प्रिंट करें"
 },
 "Cetak / Simpan PDF": {
  "en": "Print / Save PDF",
  "ar": "طباعة / حفظ PDF",
  "fr": "Imprimer / Enregistrer PDF",
  "de": "Drucken / PDF speichern",
  "es": "Imprimir / Guardar PDF",
  "ru": "Печать / Сохранить PDF",
  "zh": "打印 / 保存 PDF",
  "ja": "印刷 / PDF を保存",
  "ko": "인쇄 / PDF 저장",
  "hi": "प्रिंट करें / PDF सहेजें"
 },
 "Cuaca nyaman — pengingat otomatis akan aktif saat sangat panas.": {
  "en": "Comfortable weather — automatic reminders will activate when it is extremely hot.",
  "ar": "الطقس مناسب — ستُفعَّل التذكيرات التلقائية عند اشتداد الحر.",
  "fr": "Temps agréable — les rappels automatiques s'activeront lorsqu'il fera extrêmement chaud.",
  "de": "Angenehmes Wetter — automatische Erinnerungen werden aktiviert, wenn es extrem heiß ist.",
  "es": "Clima agradable — los recordatorios automáticos se activarán cuando haga un calor extremo.",
  "ru": "Комфортная погода — автоматические напоминания активируются при сильной жаре.",
  "zh": "天气舒适——在极热时自动提醒将会启动。",
  "ja": "気候は快適です — 非常に暑い場合に自動リマインダーが有効になります。",
  "ko": "날씨가 쾌적합니다 — 매우 더울 때 자동 알림이 활성화됩니다.",
  "hi": "मौसम सुहावना है — अत्यधिक गर्मी होने पर स्वचालित अनुस्मारक सक्रिय हो जाएंगे।"
 },
 "Cuaca sangat panas — minum 200–250 ml air sekarang, sedikit demi sedikit.": {
  "en": "The weather is very hot — drink 200–250 ml of water now, little by little.",
  "ar": "الطقس حار جداً — اشرب 200–250 مل من الماء الآن، شيئاً فشيئاً.",
  "fr": "Il fait très chaud — buvez 200–250 ml d'eau maintenant, petit à petit.",
  "de": "Das Wetter ist sehr heiß — trinken Sie jetzt 200–250 ml Wasser, schluckweise.",
  "es": "El clima es muy caluroso — beba 200–250 ml de agua ahora, poco a poco.",
  "ru": "Погода очень жаркая — выпейте сейчас 200–250 мл воды, небольшими глотками.",
  "zh": "天气非常炎热——现在慢慢喝200–250毫升水。",
  "ja": "天気がとても暑いです — 今すぐ200〜250mlの水を少しずつ飲んでください。",
  "ko": "날씨가 매우 덥습니다 — 지금 200–250ml의 물을 조금씩 드세요.",
  "hi": "मौसम बहुत गर्म है — अभी 200–250 मिली पानी थोड़ा-थोड़ा करके पिएं।"
 },
 "Cuaca tidak tersedia saat ini": {
  "en": "Weather is not available at this time",
  "ar": "الطقس غير متاح في الوقت الحالي",
  "fr": "La météo n'est pas disponible en ce moment",
  "de": "Das Wetter ist derzeit nicht verfügbar",
  "es": "El tiempo no está disponible en este momento",
  "ru": "Погода в данный момент недоступна",
  "zh": "天气信息目前不可用",
  "ja": "現在、天気情報は利用できません",
  "ko": "현재 날씨 정보를 사용할 수 없습니다",
  "hi": "मौसम की जानकारी अभी उपलब्ध नहीं है"
 },
 "Cukur / Potong": {
  "en": "Shave / Haircut",
  "ar": "حلق / تقصير",
  "fr": "Rasage / Coupe de cheveux",
  "de": "Rasieren / Haarschnitt",
  "es": "Rasurado / Corte de cabello",
  "ru": "Бритьё / Стрижка",
  "zh": "剃发 / 剪发",
  "ja": "剃髪 / 散髪",
  "ko": "삭발 / 이발",
  "hi": "मुंडन / बाल कटाना"
 },
 "Dalil Al-Qur'an": {
  "en": "Quranic Evidence",
  "ar": "دليل القرآن الكريم",
  "fr": "Preuve Coranique",
  "de": "Koranischer Beweis",
  "es": "Evidencia Coránica",
  "ru": "Доказательство из Корана",
  "zh": "《古兰经》证据",
  "ja": "クルアーンの証拠",
  "ko": "꾸란의 증거",
  "hi": "क़ुरआन की दलील"
 },
 "Dengar": {
  "en": "Listen",
  "ar": "استمع",
  "fr": "Écouter",
  "de": "Hören",
  "es": "Escuchar",
  "ru": "Слушать",
  "zh": "听",
  "ja": "聞く",
  "ko": "듣기",
  "hi": "सुनें"
 },
 "Dengar Arti": {
  "en": "Listen to the Meaning",
  "ar": "استمع إلى المعنى",
  "fr": "Écouter la Signification",
  "de": "Bedeutung Anhören",
  "es": "Escuchar el Significado",
  "ru": "Слушать Смысл",
  "zh": "聆听含义",
  "ja": "意味を聴く",
  "ko": "의미 듣기",
  "hi": "अर्थ सुनें"
 },
 "Di batas Miqat, mandi dan kenakan ihram, niatkan umrah, lalu mulai membaca Talbiyah.": {
  "en": "At the Miqat boundary, perform ghusl and put on the ihram, make the intention for Umrah, then begin reciting the Talbiyah.",
  "ar": "عند حدود الميقات، اغتسل والبس الإحرام، انوِ العمرة، ثم ابدأ في ترديد التلبية.",
  "fr": "À la limite du Miqat, effectuez le ghusl et revêtez l'ihram, formulez l'intention pour la Umrah, puis commencez à réciter la Talbiyah.",
  "de": "An der Miqat-Grenze, führe das Ghusl durch und lege den Ihram an, beabsichtige die Umrah, dann beginne mit dem Rezitieren der Talbiyah.",
  "es": "En el límite del Miqat, realiza el ghusl y ponte el ihram, formula la intención para la Umrah, luego comienza a recitar la Talbiyah.",
  "ru": "На границе Микат совершите гусль и наденьте ихрам, сделайте намерение для Умры, затем начните читать Талбию.",
  "zh": "在米卡特边界处，进行大净礼并穿上戒衣，做出乌姆拉的意图，然后开始诵读泰勒比叶。",
  "ja": "ミーカートの境界で、グスルを行いイフラームを身に着け、ウムラの意図を立て、そしてタルビヤの唱誦を始めなさい。",
  "ko": "미카트 경계에서 구슬을 행하고 이흐람을 입고, 우므라의 니야를 세운 후, 탈비야 낭송을 시작하십시오.",
  "hi": "मीकात की सीमा पर गुस्ल करें और इहराम पहनें, उमरह की नियत करें, फिर तल्बियह पढ़ना शुरू करें।"
 },
 "Di dalam": {
  "en": "Inside",
  "ar": "في الداخل",
  "fr": "À l'intérieur",
  "de": "Im Inneren",
  "es": "Dentro",
  "ru": "Внутри",
  "zh": "里面",
  "ja": "中に",
  "ko": "안에",
  "hi": "अंदर"
 },
 "Di luar ruangan": {
  "en": "Outdoors",
  "ar": "في الهواء الطلق",
  "fr": "En plein air",
  "de": "Im Freien",
  "es": "Al aire libre",
  "ru": "На улице",
  "zh": "户外",
  "ja": "屋外",
  "ko": "야외",
  "hi": "बाहर"
 },
 "Dialog pengingat muncul di halaman mana pun saat waktu salat tiba (adzan mengikuti pengaturan di atas)": {
  "en": "A reminder dialog appears on any page when prayer time arrives (adhan follows the settings above)",
  "ar": "تظهر نافذة تذكير على أي صفحة عند حلول وقت الصلاة (الأذان يتبع الإعدادات أعلاه)",
  "fr": "Une boîte de dialogue de rappel apparaît sur n'importe quelle page lorsque l'heure de la prière arrive (l'adhan suit les paramètres ci-dessus)",
  "de": "Ein Erinnerungsdialog erscheint auf jeder Seite, wenn die Gebetszeit eintrifft (Adhan folgt den obigen Einstellungen)",
  "es": "Un diálogo de recordatorio aparece en cualquier página cuando llega el tiempo de oración (el adhan sigue la configuración anterior)",
  "ru": "Диалоговое окно напоминания появляется на любой странице, когда наступает время молитвы (азан следует настройкам выше)",
  "zh": "当礼拜时间到来时，提醒对话框会出现在任何页面上（呼拜遵循上述设置）",
  "ja": "礼拝の時間になると、どのページにもリマインダーダイアログが表示されます（アザーンは上記の設定に従います）",
  "ko": "예배 시간이 되면 모든 페이지에 알림 대화상자가 표시됩니다 (아잔은 위의 설정을 따릅니다)",
  "hi": "नमाज़ का वक्त आने पर किसी भी पेज पर एक रिमाइंडर डायलॉग प्रकट होता है (अज़ान ऊपर की सेटिंग्स के अनुसार होती है)"
 },
 "Dibuat dengan Manasik — Panduan Umrah & Haji": {
  "en": "Made with Manasik — Umrah & Hajj Guide",
  "ar": "صُنع بواسطة مناسك — دليل العمرة والحج",
  "fr": "Créé avec Manasik — Guide de la Omra & du Hajj",
  "de": "Erstellt mit Manasik — Umra & Hajj Reiseführer",
  "es": "Hecho con Manasik — Guía de Umra y Hajj",
  "ru": "Создано с Manasik — Руководство по Умре и Хаджу",
  "zh": "由 Manasik 制作 — 副朝与朝觐指南",
  "ja": "Manasik で作成 — ウムラ＆ハッジガイド",
  "ko": "Manasik으로 제작 — 우므라 & 하지 가이드",
  "hi": "Manasik के साथ बनाया गया — उमरा और हज गाइड"
 },
 "Dihapus": {
  "en": "Deleted",
  "ar": "محذوف",
  "fr": "Supprimé",
  "de": "Gelöscht",
  "es": "Eliminado",
  "ru": "Удалено",
  "zh": "已删除",
  "ja": "削除済み",
  "ko": "삭제됨",
  "hi": "हटाया गया"
 },
 "Dihapus dari offline": {
  "en": "Removed from offline",
  "ar": "تمت الإزالة من وضع عدم الاتصال",
  "fr": "Supprimé du mode hors ligne",
  "de": "Aus dem Offline-Modus entfernt",
  "es": "Eliminado del modo sin conexión",
  "ru": "Удалено из автономного режима",
  "zh": "已从离线中删除",
  "ja": "オフラインから削除されました",
  "ko": "오프라인에서 제거되었습니다",
  "hi": "ऑफलाइन से हटाया गया"
 },
 "Dikunjungi": {
  "en": "Visited",
  "ar": "تمت الزيارة",
  "fr": "Visité",
  "de": "Besucht",
  "es": "Visitado",
  "ru": "Посещено",
  "zh": "已访问",
  "ja": "訪問済み",
  "ko": "방문됨",
  "hi": "दौरा किया गया"
 },
 "Doa di lokasi ini": {
  "en": "Prayer at this location",
  "ar": "الدعاء في هذا الموقع",
  "fr": "Prière en ce lieu",
  "de": "Gebet an diesem Ort",
  "es": "Oración en este lugar",
  "ru": "Молитва в этом месте",
  "zh": "此地点的祈祷",
  "ja": "この場所での祈り",
  "ko": "이 장소에서의 기도",
  "hi": "इस स्थान पर दुआ"
 },
 "Ekspor Jurnal": {
  "en": "Export Journal",
  "ar": "تصدير السجل",
  "fr": "Exporter le Journal",
  "de": "Journal Exportieren",
  "es": "Exportar Diario",
  "ru": "Экспорт Журнала",
  "zh": "导出日志",
  "ja": "ジャーナルをエクスポート",
  "ko": "저널 내보내기",
  "hi": "जर्नल निर्यात करें"
 },
 "Fadhilah & Keutamaan Tambahan": {
  "en": "Additional Virtues & Merits",
  "ar": "فضائل ومزايا إضافية",
  "fr": "Vertus et mérites supplémentaires",
  "de": "Zusätzliche Tugenden & Vorzüge",
  "es": "Virtudes y méritos adicionales",
  "ru": "Дополнительные достоинства и заслуги",
  "zh": "额外的美德与功绩",
  "ja": "追加の美徳と功績",
  "ko": "추가적인 덕목과 공덕",
  "hi": "अतिरिक्त फ़ज़ीलतें और गुण"
 },
 "Favorit": {
  "en": "Favorites",
  "ar": "المفضلة",
  "fr": "Favoris",
  "de": "Favoriten",
  "es": "Favoritos",
  "ru": "Избранное",
  "zh": "收藏",
  "ja": "お気に入り",
  "ko": "즐겨찾기",
  "hi": "पसंदीदा"
 },
 "File: {name}": {
  "en": "File: {name}",
  "ar": "ملف: {name}",
  "fr": "Fichier : {name}",
  "de": "Datei: {name}",
  "es": "Archivo: {name}",
  "ru": "Файл: {name}",
  "zh": "文件：{name}",
  "ja": "ファイル：{name}",
  "ko": "파일: {name}",
  "hi": "फ़ाइल: {name}"
 },
 "Fitur dukungan tidak tersedia pada versi aplikasi dari Google Play. Semua fitur Manasik tetap gratis sepenuhnya — terima kasih telah menggunakan aplikasi ini dan mendoakan tim kami.": {
  "en": "The support feature is not available in the Google Play version of the app. All Manasik features remain completely free — thank you for using this app and for praying for our team.",
  "ar": "ميزة الدعم غير متاحة في إصدار التطبيق من Google Play. جميع ميزات المناسك تبقى مجانية تمامًا — شكرًا لاستخدامك هذا التطبيق ولدعائك لفريقنا.",
  "fr": "La fonctionnalité de soutien n'est pas disponible dans la version Google Play de l'application. Toutes les fonctionnalités du Manasik restent entièrement gratuites — merci d'utiliser cette application et de prier pour notre équipe.",
  "de": "Die Unterstützungsfunktion ist in der Google Play-Version der App nicht verfügbar. Alle Manasik-Funktionen bleiben vollständig kostenlos — vielen Dank, dass Sie diese App nutzen und für unser Team beten.",
  "es": "La función de soporte no está disponible en la versión de Google Play de la aplicación. Todas las funciones de Manasik siguen siendo completamente gratuitas — gracias por usar esta aplicación y por orar por nuestro equipo.",
  "ru": "Функция поддержки недоступна в версии приложения из Google Play. Все функции Манасик остаются полностью бесплатными — спасибо за использование этого приложения и за молитвы за нашу команду.",
  "zh": "支持功能在 Google Play 版本的应用中不可用。所有 Manasik 功能仍然完全免费——感谢您使用本应用并为我们的团队祈祷。",
  "ja": "サポート機能はGoogle Playバージョンのアプリではご利用いただけません。すべてのマナシク機能は引き続き完全無料です — このアプリをご利用いただき、私たちのチームのためにお祈りくださりありがとうございます。",
  "ko": "지원 기능은 Google Play 버전의 앱에서는 사용할 수 없습니다. 모든 Manasik 기능은 완전히 무료로 유지됩니다 — 이 앱을 사용해 주시고 저희 팀을 위해 기도해 주셔서 감사합니다.",
  "hi": "सहायता सुविधा Google Play के ऐप संस्करण में उपलब्ध नहीं है। सभी मनासिक सुविधाएँ पूरी तरह निःशुल्क रहती हैं — इस ऐप का उपयोग करने और हमारी टीम के लिए दुआ करने के लिए शुक्रिया।"
 },
 "Foto": {
  "en": "Photo",
  "ar": "صورة",
  "fr": "Photo",
  "de": "Foto",
  "es": "Foto",
  "ru": "Фото",
  "zh": "照片",
  "ja": "写真",
  "ko": "사진",
  "hi": "फ़ोटो"
 },
 "Gagal membuat gambar jadwal.": {
  "en": "Failed to create schedule image.",
  "ar": "فشل في إنشاء صورة الجدول.",
  "fr": "Échec de la création de l'image du planning.",
  "de": "Fehler beim Erstellen des Zeitplanbildes.",
  "es": "Error al crear la imagen del horario.",
  "ru": "Не удалось создать изображение расписания.",
  "zh": "创建日程图片失败。",
  "ja": "スケジュール画像の作成に失敗しました。",
  "ko": "일정 이미지 생성에 실패했습니다.",
  "hi": "शेड्यूल छवि बनाने में विफल।"
 },
 "Gagal mengunggah foto": {
  "en": "Failed to upload photo",
  "ar": "فشل في رفع الصورة",
  "fr": "Échec du téléchargement de la photo",
  "de": "Foto hochladen fehlgeschlagen",
  "es": "Error al subir la foto",
  "ru": "Не удалось загрузить фото",
  "zh": "上传照片失败",
  "ja": "写真のアップロードに失敗しました",
  "ko": "사진 업로드 실패",
  "hi": "फ़ोटो अपलोड करने में विफल"
 },
 "Gagal menyimpan": {
  "en": "Failed to save",
  "ar": "فشل في الحفظ",
  "fr": "Échec de l'enregistrement",
  "de": "Speichern fehlgeschlagen",
  "es": "Error al guardar",
  "ru": "Не удалось сохранить",
  "zh": "保存失败",
  "ja": "保存に失敗しました",
  "ko": "저장 실패",
  "hi": "सहेजने में विफल"
 },
 "Gambar jadwal diunduh — lampirkan di WhatsApp rombongan Anda.": {
  "en": "The schedule image has been downloaded — attach it in your group's WhatsApp.",
  "ar": "تم تنزيل صورة الجدول — أرفقها في مجموعة واتساب رفقتك.",
  "fr": "L'image du planning a été téléchargée — joignez-la dans le WhatsApp de votre groupe.",
  "de": "Das Zeitplanbild wurde heruntergeladen — fügen Sie es in den WhatsApp Ihrer Reisegruppe ein.",
  "es": "La imagen del horario ha sido descargada — adjúntela en el WhatsApp de su grupo.",
  "ru": "Изображение расписания загружено — прикрепите его в WhatsApp вашей группы.",
  "zh": "日程图片已下载 — 请将其附加到您团队的WhatsApp群组中。",
  "ja": "スケジュール画像がダウンロードされました — グループのWhatsAppに添付してください。",
  "ko": "일정 이미지가 다운로드되었습니다 — 그룹 WhatsApp에 첨부하세요.",
  "hi": "शेड्यूल की छवि डाउनलोड हो गई है — इसे अपने दल के WhatsApp में संलग्न करें।"
 },
 "Gambar jadwal siap dibagikan.": {
  "en": "The schedule image is ready to be shared.",
  "ar": "صورة الجدول جاهزة للمشاركة.",
  "fr": "L'image du calendrier est prête à être partagée.",
  "de": "Das Terminplanbild ist bereit zum Teilen.",
  "es": "La imagen del horario está lista para compartir.",
  "ru": "Изображение расписания готово к публикации.",
  "zh": "日程表图片已准备好分享。",
  "ja": "スケジュール画像は共有する準備ができています。",
  "ko": "일정 이미지가 공유할 준비가 되었습니다.",
  "hi": "शेड्यूल की छवि साझा करने के लिए तैयार है।"
 },
 "Ganti mode gelap/terang": {
  "en": "Toggle dark/light mode",
  "ar": "تبديل الوضع الداكن/الفاتح",
  "fr": "Basculer mode sombre/clair",
  "de": "Dunkel-/Hellmodus umschalten",
  "es": "Cambiar modo oscuro/claro",
  "ru": "Переключить тёмный/светлый режим",
  "zh": "切换深色/浅色模式",
  "ja": "ダーク/ライトモードを切り替える",
  "ko": "다크/라이트 모드 전환",
  "hi": "डार्क/लाइट मोड टॉगल करें"
 },
 "Gerimis": {
  "en": "Drizzle",
  "ar": "رذاذ",
  "fr": "Bruine",
  "de": "Nieselregen",
  "es": "Llovizna",
  "ru": "Морось",
  "zh": "毛毛雨",
  "ja": "霧雨",
  "ko": "이슬비",
  "hi": "बूँदाबाँदी"
 },
 "Getaran arah kiblat": {
  "en": "Qibla direction vibration",
  "ar": "اهتزاز اتجاه القبلة",
  "fr": "Vibration de la direction de la Qibla",
  "de": "Qibla-Richtungsvibrierung",
  "es": "Vibración de la dirección de la Qibla",
  "ru": "Вибрация направления киблы",
  "zh": "朝拜方向震动",
  "ja": "キブラ方向の振動",
  "ko": "키블라 방향 진동",
  "hi": "क़िब्ला दिशा कंपन"
 },
 "Getaran panjang — tepat menghadap kiblat": {
  "en": "Long vibration — facing the qiblah directly",
  "ar": "اهتزاز طويل — مواجهة القبلة مباشرةً",
  "fr": "Vibration longue — face à la qiblah directement",
  "de": "Langer Vibration — direkt zur Qiblah gewandt",
  "es": "Vibración larga — mirando directamente hacia la qiblah",
  "ru": "Длинная вибрация — точно лицом к кибле",
  "zh": "长振动 — 正对朝拜方向",
  "ja": "長い振動 — キブラに正対している",
  "ko": "긴 진동 — 키블라를 정면으로 향함",
  "hi": "लंबा कंपन — क़िब्ला की ओर सीधे मुख करके"
 },
 "Getaran tiap {sec} dtk · 1 denyut (kiri)": {
  "en": "Vibration every {sec} sec · 1 pulse (left)",
  "ar": "اهتزاز كل {sec} ثانية · نبضة واحدة (يسار)",
  "fr": "Vibration toutes les {sec} sec · 1 impulsion (gauche)",
  "de": "Vibration alle {sec} Sek. · 1 Impuls (links)",
  "es": "Vibración cada {sec} seg · 1 pulso (izquierda)",
  "ru": "Вибрация каждые {sec} сек · 1 импульс (левый)",
  "zh": "每 {sec} 秒振动 · 1 次脉冲（左）",
  "ja": "{sec}秒ごとに振動 · 1パルス（左）",
  "ko": "{sec}초마다 진동 · 1회 펄스 (왼쪽)",
  "hi": "हर {sec} सेकंड में कंपन · 1 स्पंद (बाएं)"
 },
 "Getaran tiap {sec} dtk · 2 denyut (kanan)": {
  "en": "Vibration every {sec} sec · 2 pulses (right)",
  "ar": "اهتزاز كل {sec} ثانية · نبضتان (يمين)",
  "fr": "Vibration toutes les {sec} sec · 2 impulsions (droite)",
  "de": "Vibration alle {sec} Sek. · 2 Impulse (rechts)",
  "es": "Vibración cada {sec} seg · 2 pulsos (derecha)",
  "ru": "Вибрация каждые {sec} сек · 2 импульса (правая)",
  "zh": "每 {sec} 秒振动 · 2次脉冲（右）",
  "ja": "{sec}秒ごとに振動 · 2パルス（右）",
  "ko": "{sec}초마다 진동 · 2번 진동(오른쪽)",
  "hi": "हर {sec} सेकंड में कंपन · 2 स्पंद (दाएं)"
 },
 "Gunakan payung, kacamata hitam, dan sandal; basahi kepala/leher dengan air zamzam bila perlu.": {
  "en": "Use an umbrella, sunglasses, and sandals; moisten the head/neck with zamzam water if necessary.",
  "ar": "استخدم المظلة والنظارات الشمسية والصندل؛ ورطّب الرأس والرقبة بماء زمزم عند الحاجة.",
  "fr": "Utilisez un parapluie, des lunettes de soleil et des sandales ; humidifiez la tête/le cou avec de l'eau zamzam si nécessaire.",
  "de": "Verwende einen Regenschirm, eine Sonnenbrille und Sandalen; befeuchte Kopf/Nacken bei Bedarf mit Zamzam-Wasser.",
  "es": "Usa un paraguas, gafas de sol y sandalias; humedece la cabeza/el cuello con agua zamzam si es necesario.",
  "ru": "Используйте зонт, солнцезащитные очки и сандалии; при необходимости смочите голову/шею водой замзам.",
  "zh": "使用雨伞、太阳镜和凉鞋；必要时用渗渗泉水润湿头部/颈部。",
  "ja": "傘、サングラス、サンダルを使用し、必要に応じてザムザム水で頭や首を濡らしてください。",
  "ko": "우산, 선글라스, 샌들을 사용하고, 필요하면 잠잠 물로 머리/목을 적셔 주세요.",
  "hi": "छाता, धूप के चश्मे और चप्पल का उपयोग करें; आवश्यकता पड़ने पर सिर/गर्दन को ज़मज़म के पानी से गीला करें।"
 },
 "Gunakan tabir surya dan payung saat berjalan ke masjid di siang hari.": {
  "en": "Use sunscreen and an umbrella when walking to the mosque during the daytime.",
  "ar": "استخدم واقي الشمس والمظلة عند المشي إلى المسجد في وقت النهار.",
  "fr": "Utilisez de la crème solaire et un parapluie lorsque vous marchez vers la mosquée en pleine journée.",
  "de": "Verwenden Sie Sonnenschutz und einen Regenschirm, wenn Sie tagsüber zur Moschee gehen.",
  "es": "Use protector solar y paraguas al caminar hacia la mezquita durante el día.",
  "ru": "Используйте солнцезащитный крем и зонт при ходьбе в мечеть в дневное время.",
  "zh": "白天步行前往清真寺时，请使用防晒霜和雨伞。",
  "ja": "昼間にモスクへ歩いて行く際は、日焼け止めと傘をご使用ください。",
  "ko": "낮에 모스크로 걸어갈 때는 자외선 차단제와 우산을 사용하세요.",
  "hi": "दिन के समय मस्जिद की ओर चलते समय सनस्क्रीन और छाते का उपयोग करें।"
 },
 "Hadits Shahih": {
  "en": "Authentic Hadith",
  "ar": "حديث صحيح",
  "fr": "Hadith Authentique",
  "de": "Authentischer Hadith",
  "es": "Hadith Auténtico",
  "ru": "Достоверный Хадис",
  "zh": "真实圣训",
  "ja": "真正なハディース",
  "ko": "진정한 하디스",
  "hi": "सहीह हदीस"
 },
 "Haji": {
  "en": "Hajj",
  "ar": "الحج",
  "fr": "Hajj",
  "de": "Hadsch",
  "es": "Hajj",
  "ru": "Хадж",
  "zh": "朝觐",
  "ja": "ハッジ",
  "ko": "하지",
  "hi": "हज"
 },
 "Haji Dijelaskan — Rukun-Rukun Utama": {
  "en": "Hajj Explained — The Main Pillars",
  "ar": "شرح الحج — الأركان الرئيسية",
  "fr": "Le Hajj Expliqué — Les Piliers Principaux",
  "de": "Hadsch Erklärt — Die Hauptsäulen",
  "es": "El Hajj Explicado — Los Pilares Principales",
  "ru": "Хадж Разъяснён — Основные Столпы",
  "zh": "朝觐详解 — 主要支柱",
  "ja": "ハッジの解説 — 主要な柱",
  "ko": "하즈 설명 — 주요 기둥",
  "hi": "हज की व्याख्या — मुख्य स्तंभ"
 },
 "Hapus": {
  "en": "Delete",
  "ar": "حذف",
  "fr": "Supprimer",
  "de": "Löschen",
  "es": "Eliminar",
  "ru": "Удалить",
  "zh": "删除",
  "ja": "削除",
  "ko": "삭제",
  "hi": "हटाएं"
 },
 "Hapus Semua": {
  "en": "Delete All",
  "ar": "حذف الكل",
  "fr": "Tout supprimer",
  "de": "Alle löschen",
  "es": "Eliminar todo",
  "ru": "Удалить всё",
  "zh": "删除全部",
  "ja": "すべて削除",
  "ko": "모두 삭제",
  "hi": "सभी हटाएं"
 },
 "Hapus foto": {
  "en": "Delete photo",
  "ar": "حذف الصورة",
  "fr": "Supprimer la photo",
  "de": "Foto löschen",
  "es": "Eliminar foto",
  "ru": "Удалить фото",
  "zh": "删除照片",
  "ja": "写真を削除",
  "ko": "사진 삭제",
  "hi": "फ़ोटो हटाएं"
 },
 "Hari ini": {
  "en": "Today",
  "ar": "اليوم",
  "fr": "Aujourd'hui",
  "de": "Heute",
  "es": "Hoy",
  "ru": "Сегодня",
  "zh": "今天",
  "ja": "今日",
  "ko": "오늘",
  "hi": "आज"
 },
 "Hari ini hari puasa · Imsak {imsak} · Subuh {fajr}": {
  "en": "Today is a fasting day · Imsak {imsak} · Fajr {fajr}",
  "ar": "اليوم يوم صيام · الإمساك {imsak} · الفجر {fajr}",
  "fr": "Aujourd'hui est un jour de jeûne · Imsak {imsak} · Fajr {fajr}",
  "de": "Heute ist ein Fastentag · Imsak {imsak} · Fajr {fajr}",
  "es": "Hoy es un día de ayuno · Imsak {imsak} · Fajr {fajr}",
  "ru": "Сегодня день поста · Имсак {imsak} · Фаджр {fajr}",
  "zh": "今天是斋戒日 · 封斋时间 {imsak} · 晨礼 {fajr}",
  "ja": "今日は断食の日です · イムサク {imsak} · ファジュル {fajr}",
  "ko": "오늘은 금식일입니다 · 이므삭 {imsak} · 파즈르 {fajr}",
  "hi": "आज रोज़े का दिन है · इम्साक {imsak} · फ़ज्र {fajr}"
 },
 "Hari puasa berikutnya: {day}": {
  "en": "Next fasting day: {day}",
  "ar": "يوم الصيام التالي: {day}",
  "fr": "Prochain jour de jeûne : {day}",
  "de": "Nächster Fasttag: {day}",
  "es": "Próximo día de ayuno: {day}",
  "ru": "Следующий день поста: {day}",
  "zh": "下一个斋戒日：{day}",
  "ja": "次の断食日：{day}",
  "ko": "다음 금식일: {day}",
  "hi": "अगला उपवास दिवस: {day}"
 },
 "Hentikan": {
  "en": "Stop",
  "ar": "توقف",
  "fr": "Arrêter",
  "de": "Stopp",
  "es": "Detener",
  "ru": "Остановить",
  "zh": "停止",
  "ja": "停止",
  "ko": "중지",
  "hi": "रोकें"
 },
 "Hentikan pengingat": {
  "en": "Stop reminder",
  "ar": "إيقاف التذكير",
  "fr": "Arrêter le rappel",
  "de": "Erinnerung stoppen",
  "es": "Detener recordatorio",
  "ru": "Остановить напоминание",
  "zh": "停止提醒",
  "ja": "リマインダーを停止",
  "ko": "알림 중지",
  "hi": "रिमाइंडर बंद करें"
 },
 "Hijriah": {
  "en": "Hijri",
  "ar": "هجري",
  "fr": "Hégirien",
  "de": "Hijri",
  "es": "Hégira",
  "ru": "Хиджри",
  "zh": "伊斯兰历",
  "ja": "ヒジュラ暦",
  "ko": "히즈라력",
  "hi": "हिज्री"
 },
 "Hindari sengatan langsung pukul 11.00–15.00; pakai payung dan pakaian longgar berwarna terang.": {
  "en": "Avoid direct sun exposure from 11:00–15:00; use an umbrella and wear loose, light-colored clothing.",
  "ar": "تجنب أشعة الشمس المباشرة من الساعة 11:00 حتى 15:00؛ استخدم المظلة وارتدِ ملابس فضفاضة ذات ألوان فاتحة.",
  "fr": "Évitez l'exposition directe au soleil de 11h00 à 15h00 ; utilisez un parapluie et portez des vêtements amples de couleur claire.",
  "de": "Vermeiden Sie direkte Sonneneinstrahlung von 11:00–15:00 Uhr; benutzen Sie einen Sonnenschirm und tragen Sie lockere, hell gefärbte Kleidung.",
  "es": "Evite la exposición directa al sol de 11:00 a 15:00; use sombrilla y vista ropa holgada de colores claros.",
  "ru": "Избегайте прямых солнечных лучей с 11:00 до 15:00; пользуйтесь зонтом и носите свободную одежду светлых тонов.",
  "zh": "避免在11:00–15:00期间直接暴露在阳光下；请使用遮阳伞并穿着宽松的浅色衣物。",
  "ja": "11:00〜15:00の間は直射日光を避け、日傘を使用し、ゆったりとした明るい色の服を着用してください。",
  "ko": "11:00~15:00 사이에는 직사광선을 피하고, 양산을 사용하며 밝은 색의 헐렁한 옷을 착용하세요.",
  "hi": "सुबह 11:00 से दोपहर 15:00 बजे तक सीधी धूप से बचें; छाता उपयोग करें और हल्के रंग के ढीले कपड़े पहनें।"
 },
 "Hujan": {
  "en": "Rain",
  "ar": "مطر",
  "fr": "Pluie",
  "de": "Regen",
  "es": "Lluvia",
  "ru": "Дождь",
  "zh": "雨",
  "ja": "雨",
  "ko": "비",
  "hi": "बारिश"
 },
 "Ikuti pergerakan jamaah pada hari raya: Arafah → Muzdalifah → Mina": {
  "en": "Follow the movement of pilgrims on the day of Eid: Arafah → Muzdalifah → Mina",
  "ar": "تابع حركة الحجاج في يوم العيد: عرفة → مزدلفة → منى",
  "fr": "Suivez le déplacement des pèlerins le jour de l'Aïd : Arafah → Muzdalifah → Mina",
  "de": "Verfolgen Sie die Bewegung der Pilger am Festtag: Arafah → Muzdalifah → Mina",
  "es": "Siga el movimiento de los peregrinos el día de Eid: Arafah → Muzdalifah → Mina",
  "ru": "Следите за передвижением паломников в день Eid: Арафат → Муздалифа → Мина",
  "zh": "在节日当天追踪朝圣者的行程：阿拉法特 → 穆兹达利法 → 米纳",
  "ja": "祭日における巡礼者の移動を追う：アラファー → ムズダリファ → ミナー",
  "ko": "명절 날 순례자들의 이동을 따라가세요: 아라파 → 무즈달리파 → 미나",
  "hi": "ईद के दिन हाजियों की आवाजाही को फॉलो करें: अरफ़ाह → मुज़्दलिफ़ा → मिना"
 },
 "Ikuti rangkaian ibadah: Miqat → Tawaf → Sa'i → Tahallul": {
  "en": "Follow the sequence of worship: Miqat → Tawaf → Sa'i → Tahallul",
  "ar": "اتبع تسلسل العبادة: الميقات → الطواف → السعي → التحلل",
  "fr": "Suivez la séquence des actes d'adoration : Miqat → Tawaf → Sa'i → Tahallul",
  "de": "Folgen Sie der Abfolge der Gottesverehrung: Miqat → Tawaf → Sa'i → Tahallul",
  "es": "Siga la secuencia de adoración: Miqat → Tawaf → Sa'i → Tahallul",
  "ru": "Следуйте последовательности поклонения: Микат → Таваф → Са'и → Тахаллул",
  "zh": "按照礼拜顺序进行：米卡特 → 绕行（塔瓦夫）→ 奔走（萨依）→ 解戒（塔哈鲁尔）",
  "ja": "礼拝の順序に従ってください：ミーカート → タワーフ → サアイ → タハッルル",
  "ko": "예배 순서를 따르십시오: 미카트 → 타와프 → 사이 → 타할룰",
  "hi": "礼拝의 순서를 따르세요: मीकात → तवाफ → सई → तहल्लुल"
 },
 "Ilustrasi": {
  "en": "Illustration",
  "ar": "رسم توضيحي",
  "fr": "Illustration",
  "de": "Illustration",
  "es": "Ilustración",
  "ru": "Иллюстрация",
  "zh": "插图",
  "ja": "イラスト",
  "ko": "일러스트",
  "hi": "चित्रण"
 },
 "Imsak": {
  "en": "Imsak",
  "ar": "الإمساك",
  "fr": "Imsak",
  "de": "Imsak",
  "es": "Imsak",
  "ru": "Имсак",
  "zh": "封斋开始时间",
  "ja": "イムサク",
  "ko": "임삭",
  "hi": "इम्साक"
 },
 "Imsak = 10 menit sebelum Subuh menurut jadwal lokasi Anda. Pengingat sahur dikirim sebelum Imsak, lalu saat Imsak tiba.": {
  "en": "Imsak = 10 minutes before Fajr according to your location's schedule. A suhoor reminder is sent before Imsak, then when Imsak arrives.",
  "ar": "الإمساك = 10 دقائق قبل الفجر وفقاً لجدول موقعك. يُرسَل تذكير السحور قبل الإمساك، ثم عند حلول وقت الإمساك.",
  "fr": "Imsak = 10 minutes avant le Fajr selon l'horaire de votre localité. Un rappel pour le Suhoor est envoyé avant l'Imsak, puis à l'arrivée de l'Imsak.",
  "de": "Imsak = 10 Minuten vor dem Fajr gemäß dem Zeitplan Ihres Standorts. Eine Suhoor-Erinnerung wird vor dem Imsak gesendet, dann wenn der Imsak eintrifft.",
  "es": "Imsak = 10 minutos antes del Fajr según el horario de su ubicación. Se envía un recordatorio de Suhoor antes del Imsak y luego cuando llega el Imsak.",
  "ru": "Имсак = 10 минут до Фаджра согласно расписанию вашего местоположения. Напоминание о сухуре отправляется до Имсака, затем в момент наступления Имсака.",
  "zh": "封斋时间（Imsak）= 根据您所在位置的时间表，在晨礼（Fajr）前10分钟。封斋提醒将在Imsak之前发送，然后在Imsak到来时再次发送。",
  "ja": "イムサク（Imsak）= お住まいの地域のスケジュールに基づき、ファジュル（Fajr）の10分前です。スフール（Suhoor）のリマインダーはイムサクの前に送信され、次にイムサクが来た時にも送信されます。",
  "ko": "이므삭(Imsak) = 귀하의 위치 일정에 따라 파즈르(Fajr) 10분 전입니다. 수후르(Suhoor) 알림은 이므삭 전에 발송되며, 이므삭이 시작될 때 다시 발송됩니다.",
  "hi": "इम्साक (Imsak) = आपके स्थान के शेड्यूल के अनुसार फज्र से 10 मिनट पहले। सहरी का अनुस्मारक इम्साक से पहले भेजा जाता है, फिर इम्साक आने पर भेजा जाता है।"
 },
 "Imsak {lead} menit lagi (pukul {imsak}). Selesaikan sahur dan niat puasa.": {
  "en": "Imsak is in {lead} minutes (at {imsak}). Finish your suhoor and make your fasting intention.",
  "ar": "تبقى {lead} دقيقة على الإمساك (الساعة {imsak}). أنهِ سحورك وانوِ الصيام.",
  "fr": "L'imsak est dans {lead} minutes (à {imsak}). Terminez votre suhoor et formulez votre intention de jeûne.",
  "de": "Der Imsak beginnt in {lead} Minuten (um {imsak} Uhr). Beende dein Suhoor und fasse deine Fastenabsicht.",
  "es": "El imsak es en {lead} minutos (a las {imsak}). Termina tu suhoor y realiza tu intención de ayuno.",
  "ru": "До имсака осталось {lead} минут (в {imsak}). Завершите сухур и сделайте намерение держать пост.",
  "zh": "距封斋（封斋时间 {imsak}）还有 {lead} 分钟。请完成封斋前餐并立下封斋意念。",
  "ja": "イムサークまであと{lead}分です（{imsak}）。スフールを終え、断食のニーヤを行ってください。",
  "ko": "이므사크까지 {lead}분 남았습니다（{imsak}）. 수후르를 마치고 단식 니야를 하세요.",
  "hi": "इम्साक में {lead} मिनट शेष हैं ({imsak} बजे)। अपना सुहूर समाप्त करें और रोज़े की निय्यत करें।"
 },
 "Ingatkan Dekat Situs": {
  "en": "Remind Near Site",
  "ar": "تذكير بالقرب من الموقع",
  "fr": "Rappel à Proximité du Site",
  "de": "Erinnerung in der Nähe des Standorts",
  "es": "Recordatorio Cerca del Sitio",
  "ru": "Напоминание вблизи объекта",
  "zh": "靠近景点提醒",
  "ja": "サイト近くでリマインド",
  "ko": "사이트 근처 알림",
  "hi": "स्थल के निकट अनुस्मारक"
 },
 "Izinkan akses lokasi untuk arah yang akurat": {
  "en": "Allow location access for accurate directions",
  "ar": "اسمح بالوصول إلى الموقع للحصول على اتجاهات دقيقة",
  "fr": "Autoriser l'accès à la localisation pour des directions précises",
  "de": "Standortzugriff für genaue Wegbeschreibungen zulassen",
  "es": "Permitir acceso a la ubicación para direcciones precisas",
  "ru": "Разрешите доступ к местоположению для точных маршрутов",
  "zh": "允许位置访问以获取准确的方向",
  "ja": "正確な道順のために位置情報へのアクセスを許可してください",
  "ko": "정확한 방향을 위해 위치 접근을 허용하세요",
  "hi": "सटीक दिशाओं के लिए स्थान पहुँच की अनुमति दें"
 },
 "Izinkan lokasi": {
  "en": "Allow location",
  "ar": "السماح بالموقع",
  "fr": "Autoriser la localisation",
  "de": "Standort erlauben",
  "es": "Permitir ubicación",
  "ru": "Разрешить местоположение",
  "zh": "允许位置",
  "ja": "位置情報を許可する",
  "ko": "위치 허용",
  "hi": "स्थान की अनुमति दें"
 },
 "Izinkan notifikasi agar pengingat sahur & Imsak dikirim walau aplikasi tertutup.": {
  "en": "Allow notifications so that Suhoor & Imsak reminders can be sent even when the app is closed.",
  "ar": "اسمح بالإشعارات حتى يمكن إرسال تذكيرات السحور والإمساك حتى عند إغلاق التطبيق.",
  "fr": "Autorisez les notifications afin que les rappels du Suhoor et de l'Imsak puissent être envoyés même lorsque l'application est fermée.",
  "de": "Erlauben Sie Benachrichtigungen, damit Suhoor- und Imsak-Erinnerungen auch bei geschlossener App gesendet werden können.",
  "es": "Permita las notificaciones para que los recordatorios de Suhoor e Imsak puedan enviarse incluso cuando la aplicación esté cerrada.",
  "ru": "Разрешите уведомления, чтобы напоминания о Сухуре и Имсаке отправлялись даже при закрытом приложении.",
  "zh": "请允许通知，以便即使应用程序关闭时也能发送封斋前餐（Suhoor）和封斋开始（Imsak）提醒。",
  "ja": "アプリが閉じていても、スフールとイムサクのリマインダーが送信されるように通知を許可してください。",
  "ko": "앱이 닫혀 있어도 수후르 및 임삭 알림이 전송될 수 있도록 알림을 허용해 주세요.",
  "hi": "सूचनाओं की अनुमति दें ताकि ऐप बंद होने पर भी सुहूर और इम्साक के रिमाइंडर भेजे जा सकें।"
 },
 "Jadwal Salat Bulanan": {
  "en": "Monthly Prayer Schedule",
  "ar": "جدول الصلاة الشهري",
  "fr": "Calendrier Mensuel des Prières",
  "de": "Monatlicher Gebetsplan",
  "es": "Horario Mensual de Oraciones",
  "ru": "Ежемесячное расписание молитв",
  "zh": "每月礼拜时间表",
  "ja": "月間礼拝スケジュール",
  "ko": "월간 예배 일정",
  "hi": "मासिक नमाज़ का समय-सारणी"
 },
 "Jadwal salat": {
  "en": "Prayer Schedule",
  "ar": "جدول الصلاة",
  "fr": "Horaires des prières",
  "de": "Gebetszeiten",
  "es": "Horario de oraciones",
  "ru": "Расписание молитв",
  "zh": "礼拜时间表",
  "ja": "礼拝スケジュール",
  "ko": "예배 일정",
  "hi": "नमाज़ का समय-सारणी"
 },
 "Jam zona waktu lokasi ({tz}) · jam perangkat Anda {device}": {
  "en": "Time zone of location ({tz}) · your device time {device}",
  "ar": "توقيت المنطقة الزمنية للموقع ({tz}) · توقيت جهازك {device}",
  "fr": "Heure du fuseau horaire du lieu ({tz}) · heure de votre appareil {device}",
  "de": "Zeitzone des Standorts ({tz}) · Gerätezeit {device}",
  "es": "Hora de la zona horaria del lugar ({tz}) · hora de su dispositivo {device}",
  "ru": "Время часового пояса места ({tz}) · время вашего устройства {device}",
  "zh": "所在地时区时间（{tz}）· 您的设备时间 {device}",
  "ja": "場所のタイムゾーン時刻（{tz}）· お使いのデバイスの時刻 {device}",
  "ko": "위치 시간대 시각({tz}) · 기기 시각 {device}",
  "hi": "स्थान के समय क्षेत्र का समय ({tz}) · आपके डिवाइस का समय {device}"
 },
 "Jarak jejak ziarah": {
  "en": "Distance of pilgrimage trail",
  "ar": "مسافة مسار الزيارة",
  "fr": "Distance du parcours de pèlerinage",
  "de": "Entfernung des Pilgerpfades",
  "es": "Distancia del recorrido de peregrinación",
  "ru": "Расстояние паломнического маршрута",
  "zh": "朝圣路线距离",
  "ja": "巡礼ルートの距離",
  "ko": "순례 경로 거리",
  "hi": "तीर्थयात्रा मार्ग की दूरी"
 },
 "Jurnal": {
  "en": "Journal",
  "ar": "يوميات",
  "fr": "Journal",
  "de": "Tagebuch",
  "es": "Diario",
  "ru": "Журнал",
  "zh": "日志",
  "ja": "ジャーナル",
  "ko": "저널",
  "hi": "जर्नल"
 },
 "Jurnal Ziarah": {
  "en": "Pilgrimage Journal",
  "ar": "يوميات الزيارة",
  "fr": "Journal de Pèlerinage",
  "de": "Pilgerreise-Tagebuch",
  "es": "Diario de Peregrinación",
  "ru": "Журнал Паломничества",
  "zh": "朝圣日志",
  "ja": "巡礼日記",
  "ko": "순례 일지",
  "hi": "तीर्थयात्रा पत्रिका"
 },
 "Jurnal tersimpan": {
  "en": "Saved Journal",
  "ar": "المجلة المحفوظة",
  "fr": "Journal enregistré",
  "de": "Gespeichertes Tagebuch",
  "es": "Diario guardado",
  "ru": "Сохранённый журнал",
  "zh": "已保存的日志",
  "ja": "保存済みジャーナル",
  "ko": "저장된 일지",
  "hi": "सहेजी गई जर्नल"
 },
 "Kelola Unduhan": {
  "en": "Manage Downloads",
  "ar": "إدارة التنزيلات",
  "fr": "Gérer les téléchargements",
  "de": "Downloads verwalten",
  "es": "Administrar descargas",
  "ru": "Управление загрузками",
  "zh": "管理下载",
  "ja": "ダウンロードの管理",
  "ko": "다운로드 관리",
  "hi": "डाउनलोड प्रबंधित करें"
 },
 "Kelola audio kisah & doa tersimpan": {
  "en": "Manage saved stories & prayers audio",
  "ar": "إدارة الصوت المحفوظ للقصص والأدعية",
  "fr": "Gérer l'audio des histoires et prières sauvegardées",
  "de": "Gespeicherte Geschichten & Gebete Audio verwalten",
  "es": "Gestionar el audio de historias y oraciones guardadas",
  "ru": "Управление сохранёнными аудио историй и молитв",
  "zh": "管理已保存的故事与祈祷音频",
  "ja": "保存されたストーリーと祈りの音声を管理する",
  "ko": "저장된 이야기 및 기도 오디오 관리",
  "hi": "सहेजी गई कहानियों और प्रार्थनाओं की ऑडियो प्रबंधित करें"
 },
 "Keluar simulasi": {
  "en": "Exit simulation",
  "ar": "الخروج من المحاكاة",
  "fr": "Quitter la simulation",
  "de": "Simulation beenden",
  "es": "Salir de la simulación",
  "ru": "Выйти из симуляции",
  "zh": "退出模拟",
  "ja": "シミュレーションを終了する",
  "ko": "시뮬레이션 종료",
  "hi": "सिमुलेशन से बाहर निकलें"
 },
 "Kembali": {
  "en": "Back",
  "ar": "رجوع",
  "fr": "Retour",
  "de": "Zurück",
  "es": "Volver",
  "ru": "Назад",
  "zh": "返回",
  "ja": "戻る",
  "ko": "뒤로",
  "hi": "वापस"
 },
 "Kenali gejala heat stroke: pusing, mual, kulit panas-kering, bingung — segera ke pos kesehatan terdekat.": {
  "en": "Recognize heat stroke symptoms: dizziness, nausea, hot-dry skin, confusion — go immediately to the nearest health post.",
  "ar": "تعرّف على أعراض ضربة الشمس: الدوخة، والغثيان، والجلد الحار الجاف، والارتباك — توجّه فوراً إلى أقرب نقطة طبية.",
  "fr": "Reconnaissez les symptômes du coup de chaleur : vertiges, nausées, peau chaude et sèche, confusion — rendez-vous immédiatement au poste de santé le plus proche.",
  "de": "Erkennen Sie die Symptome eines Hitzschlags: Schwindel, Übelkeit, heiße-trockene Haut, Verwirrtheit — begeben Sie sich sofort zum nächsten Sanitätsposten.",
  "es": "Reconozca los síntomas del golpe de calor: mareos, náuseas, piel caliente y seca, confusión — diríjase de inmediato al puesto de salud más cercano.",
  "ru": "Распознайте симптомы теплового удара: головокружение, тошнота, горячая сухая кожа, спутанность сознания — немедленно обратитесь на ближайший медицинский пост.",
  "zh": "识别中暑症状：头晕、恶心、皮肤发热干燥、神志不清——立即前往最近的医疗站。",
  "ja": "熱中症の症状を見極めてください：めまい、吐き気、熱くて乾いた肌、混乱——すぐに最寄りの医療ポストへ向かってください。",
  "ko": "열사병 증상을 인지하세요: 어지러움, 메스꺼움, 뜨겁고 건조한 피부, 혼란 — 즉시 가장 가까운 의료소로 가십시오.",
  "hi": "हीट स्ट्रोक के लक्षण पहचानें: चक्कर आना, मतली, गर्म-सूखी त्वचा, भ्रम — तुरंत निकटतम स्वास्थ्य केंद्र पर जाएं।"
 },
 "Kenangan ziarah saya": {
  "en": "My pilgrimage memories",
  "ar": "ذكريات زيارتي",
  "fr": "Mes souvenirs de pèlerinage",
  "de": "Meine Pilgererinnerungen",
  "es": "Mis recuerdos de peregrinación",
  "ru": "Воспоминания о моём паломничестве",
  "zh": "我的朝圣回忆",
  "ja": "私の巡礼の思い出",
  "ko": "나의 순례 추억",
  "hi": "मेरी तीर्थयात्रा की यादें"
 },
 "Ketuk untuk kompas penuh": {
  "en": "Tap for full compass",
  "ar": "اضغط للحصول على البوصلة الكاملة",
  "fr": "Appuyez pour la boussole complète",
  "de": "Tippen für vollständigen Kompass",
  "es": "Toca para la brújula completa",
  "ru": "Нажмите для полного компаса",
  "zh": "点击查看完整指南针",
  "ja": "フルコンパスをタップ",
  "ko": "전체 나침반을 보려면 탭하세요",
  "hi": "पूर्ण कम्पास के लिए टैप करें"
 },
 "Ketuk untuk memutar adzan": {
  "en": "Tap to play the adhan",
  "ar": "اضغط لتشغيل الأذان",
  "fr": "Appuyez pour lire l'adhan",
  "de": "Tippen um den Adhan abzuspielen",
  "es": "Toca para reproducir el adhan",
  "ru": "Нажмите для воспроизведения азана",
  "zh": "点击播放呼礼",
  "ja": "アザーンを再生するにはタップしてください",
  "ko": "아잔을 재생하려면 탭하세요",
  "hi": "अज़ान चलाने के लिए टैप करें"
 },
 "Keutamaan Haji & Umrah": {
  "en": "The Virtues of Hajj & Umrah",
  "ar": "فضائل الحج والعمرة",
  "fr": "Les Vertus du Hajj & de la Omra",
  "de": "Die Vorzüge von Haddsch & Umra",
  "es": "Las Virtudes del Hayy & la Umra",
  "ru": "Достоинства Хаджа и Умры",
  "zh": "朝觐与副朝的美德",
  "ja": "ハッジとウムラの美徳",
  "ko": "하지와 움라의 덕목",
  "hi": "हज और उमरा की फ़ज़ीलत"
 },
 "Kiblat": {
  "en": "Qibla",
  "ar": "القبلة",
  "fr": "Qibla",
  "de": "Qibla",
  "es": "Qibla",
  "ru": "Кибла",
  "zh": "朝拜方向（基布拉）",
  "ja": "キブラ",
  "ko": "키블라",
  "hi": "क़िब्ला"
 },
 "Kiblat ditemukan. Anda kini menghadap kiblat.": {
  "en": "Qibla found. You are now facing the Qibla.",
  "ar": "تم العثور على القبلة. أنت الآن تواجه القبلة.",
  "fr": "Qibla trouvée. Vous faites maintenant face à la Qibla.",
  "de": "Qibla gefunden. Sie sind jetzt in Richtung Qibla ausgerichtet.",
  "es": "Qibla encontrada. Ahora estás mirando hacia la Qibla.",
  "ru": "Кибла найдена. Теперь вы обращены лицом к Кибле.",
  "zh": "已找到朝拜方向。您现在面朝朝拜方向（基卜拉）。",
  "ja": "キブラが見つかりました。あなたは今、キブラの方向を向いています。",
  "ko": "끼블라를 찾았습니다. 이제 끼블라 방향을 향하고 있습니다.",
  "hi": "क़िब्ला मिल गया। अब आप क़िब्ला की दिशा में हैं।"
 },
 "Kompas Kiblat": {
  "en": "Qibla Compass",
  "ar": "بوصلة القبلة",
  "fr": "Boussole de la Qibla",
  "de": "Qibla-Kompass",
  "es": "Brújula de la Qibla",
  "ru": "Компас Киблы",
  "zh": "朝拜方向指南针",
  "ja": "キブラコンパス",
  "ko": "키블라 나침반",
  "hi": "क़िब्ला कम्पास"
 },
 "Kompas Kiblat Live": {
  "en": "Qibla Compass Live",
  "ar": "بوصلة القبلة المباشرة",
  "fr": "Boussole Qibla en Direct",
  "de": "Qibla-Kompass Live",
  "es": "Brújula Qibla en Vivo",
  "ru": "Компас Киблы Live",
  "zh": "朝拜方向实时指南针",
  "ja": "キブラコンパス ライブ",
  "ko": "키블라 나침반 라이브",
  "hi": "क़िब्ला कम्पास लाइव"
 },
 "Kompas aktif — berputar mengikuti HP": {
  "en": "Compass active — rotates with the phone",
  "ar": "البوصلة نشطة — تدور مع الهاتف",
  "fr": "Boussole active — tourne avec le téléphone",
  "de": "Kompass aktiv — dreht sich mit dem Telefon",
  "es": "Brújula activa — gira con el teléfono",
  "ru": "Компас активен — вращается вместе с телефоном",
  "zh": "指南针已激活 — 随手机旋转",
  "ja": "コンパスがアクティブ — スマホに合わせて回転します",
  "ko": "나침반 활성화 — 휴대폰과 함께 회전",
  "hi": "कम्पास सक्रिय — फ़ोन के साथ घूमता है"
 },
 "Kompas kiblat langsung dengan pengumuman suara dan getaran saat menghadap kiblat": {
  "en": "Qibla compass with instant voice announcement and vibration when facing the Qibla",
  "ar": "بوصلة القبلة مع إعلان صوتي فوري واهتزاز عند الاتجاه نحو القبلة",
  "fr": "Boussole Qibla avec annonce vocale instantanée et vibration lors de l'orientation vers la Qibla",
  "de": "Qibla-Kompass mit sofortiger Sprachansage und Vibration beim Ausrichten zur Qibla",
  "es": "Brújula de Qibla con anuncio de voz instantáneo y vibración al orientarse hacia la Qibla",
  "ru": "Компас киблы с мгновенным голосовым объявлением и вибрацией при направлении к кибле",
  "zh": "朝拜方向指南针，朝向麦加方向时即时语音播报和振动提示",
  "ja": "キブラコンパス、キブラの方向を向いた際に即時音声アナウンスとバイブレーション機能付き",
  "ko": "키블라 나침반, 키블라 방향을 향할 때 즉각적인 음성 안내 및 진동 기능 제공",
  "hi": "क़िब्ला कम्पास जो क़िब्ला की दिशा में मुड़ने पर तत्काल ध्वनि घोषणा और कंपन करता है"
 },
 "Kompas kiblat langsung dengan pengumuman suara saat menghadap kiblat": {
  "en": "Qibla compass with voice announcement when facing the Qibla",
  "ar": "بوصلة القبلة مع إعلان صوتي عند الاتجاه نحو القبلة",
  "fr": "Boussole de qibla avec annonce vocale lors de l'orientation vers la qibla",
  "de": "Qibla-Kompass mit Sprachansage beim Ausrichten zur Qibla",
  "es": "Brújula de qibla con anuncio de voz al orientarse hacia la qibla",
  "ru": "Компас киблы с голосовым оповещением при направлении в сторону киблы",
  "zh": "朝向麦加方向时带语音提示的朝拜方向指南针",
  "ja": "キブラに向いた際に音声アナウンスが流れるキブラコンパス",
  "ko": "끼블라 방향을 향할 때 음성 안내가 제공되는 끼블라 나침반",
  "hi": "क़िबला की दिशा में मुड़ने पर आवाज़ी घोषणा के साथ क़िबला कंपास"
 },
 "Kurangi kafein dan minuman manis; perbanyak buah berair (semangka, kurma, jeruk).": {
  "en": "Reduce caffeine and sugary drinks; increase water-rich fruits (watermelon, dates, oranges).",
  "ar": "قلّل من الكافيين والمشروبات السكرية؛ وأكثر من الفواكه الغنية بالماء (البطيخ، والتمر، والبرتقال).",
  "fr": "Réduisez la caféine et les boissons sucrées ; consommez davantage de fruits riches en eau (pastèque, dattes, oranges).",
  "de": "Reduzieren Sie Koffein und zuckerhaltige Getränke; essen Sie mehr wasserreiche Früchte (Wassermelone, Datteln, Orangen).",
  "es": "Reduce la cafeína y las bebidas azucaradas; aumenta el consumo de frutas ricas en agua (sandía, dátiles, naranjas).",
  "ru": "Сократите потребление кофеина и сладких напитков; употребляйте больше сочных фруктов (арбуз, финики, апельсины).",
  "zh": "减少咖啡因和含糖饮料的摄入；多吃富含水分的水果（西瓜、椰枣、橙子）。",
  "ja": "カフェインや甘い飲み物を減らし、水分の多い果物（スイカ、ナツメヤシ、オレンジ）を多く摂りましょう。",
  "ko": "카페인과 달콤한 음료를 줄이고, 수분이 풍부한 과일(수박, 대추야자, 오렌지)을 많이 드세요.",
  "hi": "कैफीन और मीठे पेय पदार्थ कम करें; पानी से भरपूर फल (तरबूज, खजूर, संतरे) अधिक खाएं।"
 },
 "Lihat semua": {
  "en": "See all",
  "ar": "عرض الكل",
  "fr": "Voir tout",
  "de": "Alle anzeigen",
  "es": "Ver todo",
  "ru": "Смотреть все",
  "zh": "查看全部",
  "ja": "すべて見る",
  "ko": "모두 보기",
  "hi": "सभी देखें"
 },
 "Lokasi": {
  "en": "Location",
  "ar": "الموقع",
  "fr": "Emplacement",
  "de": "Standort",
  "es": "Ubicación",
  "ru": "Местоположение",
  "zh": "位置",
  "ja": "場所",
  "ko": "위치",
  "hi": "स्थान"
 },
 "Lokasi Saya": {
  "en": "My Location",
  "ar": "موقعي",
  "fr": "Ma Position",
  "de": "Mein Standort",
  "es": "Mi Ubicación",
  "ru": "Моё местоположение",
  "zh": "我的位置",
  "ja": "現在地",
  "ko": "내 위치",
  "hi": "मेरा स्थान"
 },
 "Lokasi saat ini": {
  "en": "Current location",
  "ar": "الموقع الحالي",
  "fr": "Emplacement actuel",
  "de": "Aktueller Standort",
  "es": "Ubicación actual",
  "ru": "Текущее местоположение",
  "zh": "当前位置",
  "ja": "現在地",
  "ko": "현재 위치",
  "hi": "वर्तमान स्थान"
 },
 "Mabit di Muzdalifah": {
  "en": "Mabit at Muzdalifah",
  "ar": "المبيت في المزدلفة",
  "fr": "Mabit à Muzdalifah",
  "de": "Mabit in Muzdalifah",
  "es": "Mabit en Muzdalifah",
  "ru": "Мабит в Муздалифе",
  "zh": "在穆兹代里法过夜（马比特）",
  "ja": "ムズダリファでのマビット",
  "ko": "무즈달리파에서의 마비트",
  "hi": "मुज़दलिफ़ा में मबीत"
 },
 "Makam Nabi ﷺ": {
  "en": "The Grave of the Prophet ﷺ",
  "ar": "مقام النبي ﷺ",
  "fr": "Le Mausolée du Prophète ﷺ",
  "de": "Das Grab des Propheten ﷺ",
  "es": "La Tumba del Profeta ﷺ",
  "ru": "Могила Пророка ﷺ",
  "zh": "先知ﷺ的圣墓",
  "ja": "預言者ﷺの御廟",
  "ko": "예언자 ﷺ의 묘소",
  "hi": "नबी ﷺ की मज़ार"
 },
 "Malam 10 Dzulhijjah": {
  "en": "Night of 10 Dhul Hijjah",
  "ar": "ليلة العاشر من ذي الحجة",
  "fr": "Nuit du 10 Dhul Hijjah",
  "de": "Nacht des 10. Dhul Hijjah",
  "es": "Noche del 10 de Dhul Hijjah",
  "ru": "Ночь 10 Зуль-Хиджа",
  "zh": "杜尔黑哲月第10夜",
  "ja": "ズルヒッジャの10夜目",
  "ko": "둘히자 10일의 밤",
  "hi": "ज़ुल हिज्जा की 10वीं रात"
 },
 "Manasik Umrah Lengkap Sesuai Sunnah": {
  "en": "Complete Umrah Manasik According to the Sunnah",
  "ar": "مناسك العمرة الكاملة وفق السنة النبوية",
  "fr": "Rites complets de la Oumra conformément à la Sounna",
  "de": "Vollständige Umrah-Riten gemäß der Sunnah",
  "es": "Ritos completos de la Umrah según la Sunnah",
  "ru": "Полное руководство по обрядам Умры в соответствии с Сунной",
  "zh": "完整的副朝仪式，依照逊奈",
  "ja": "スンナに基づく完全なウムラの作法",
  "ko": "순나에 따른 완전한 우므라 의식",
  "hi": "सुन्नाह के अनुसार पूर्ण उमराह मनासिक"
 },
 "Melempar Jumrah — Panduan Haji Animasi": {
  "en": "Stoning the Jamarat — Animated Hajj Guide",
  "ar": "رمي الجمرات — دليل الحج المتحرك",
  "fr": "Lapidation des Jamarât — Guide du Hajj Animé",
  "de": "Steinigung der Dschamarât — Animierter Hajj-Führer",
  "es": "Lapidación de las Jamarat — Guía Animada del Hajj",
  "ru": "Побивание Джамарат — Анимированное Руководство по Хаджу",
  "zh": "投掷贾马拉特 — 动画朝觐指南",
  "ja": "ジャマラートへの投石 — アニメーションハッジガイド",
  "ko": "자마라트 투석 — 애니메이션 하지 가이드",
  "hi": "जमरात को कंकड़ मारना — एनिमेटेड हज मार्गदर्शिका"
 },
 "Melontar Jamratul Aqabah lalu ketiga jumrah pada hari Tasyriq, menyembelih hadyu, dan tahallul.": {
  "en": "Stoning Jamratul Aqabah then all three Jamarat on the days of Tashriq, slaughtering the hadyu, and performing tahallul.",
  "ar": "رمي جمرة العقبة ثم الجمرات الثلاث في أيام التشريق، وذبح الهدي، والتحلل.",
  "fr": "Lapidation de Jamratul Aqabah puis des trois Jamarat durant les jours de Tashriq, immolation du hadyu, et accomplissement du tahallul.",
  "de": "Steinigung der Jamratul Aqabah und dann aller drei Jamarat an den Tagen von Tashriq, Schlachtung des Hadyu und Durchführung des Tahallul.",
  "es": "Lapidación de Jamratul Aqabah y luego las tres Jamarat durante los días de Tashriq, sacrificio del hadyu y realización del tahallul.",
  "ru": "Бросание камней в Джамрат аль-Акаба, затем во все три Джамарат в дни Ташрика, заклание хадью и совершение тахаллула.",
  "zh": "投掷阿卡巴石柱，然后在塔什里格日投掷三根石柱，宰杀哈迪礼牲，以及进行塔哈鲁勒。",
  "ja": "タシュリークの日々にジャムラトゥル・アカバ、次いで三つのジャマラートへの投石、ハディュの屠殺、そしてタハッルルの実施。",
  "ko": "타슈리크의 날들에 잠라툴 아카바 및 세 개의 자마라트에 투석하고, 하디유를 도살하며, 타할룰을 수행함.",
  "hi": "तश्रीक के दिनों में जमरतुल अक़बह और फिर तीनों जमरात पर कंकरी मारना, हदयु की कुर्बानी करना, और तहल्लुल करना।"
 },
 "Memuat cuaca…": {
  "en": "Loading weather…",
  "ar": "جارٍ تحميل الطقس…",
  "fr": "Chargement de la météo…",
  "de": "Wetter wird geladen…",
  "es": "Cargando el clima…",
  "ru": "Загрузка погоды…",
  "zh": "正在加载天气…",
  "ja": "天気を読み込み中…",
  "ko": "날씨 불러오는 중…",
  "hi": "मौसम लोड हो रहा है…"
 },
 "Mencari lokasi Anda…": {
  "en": "Searching for your location…",
  "ar": "جارٍ البحث عن موقعك…",
  "fr": "Recherche de votre position…",
  "de": "Suche nach Ihrem Standort…",
  "es": "Buscando su ubicación…",
  "ru": "Поиск вашего местоположения…",
  "zh": "正在搜索您的位置…",
  "ja": "現在地を検索中…",
  "ko": "위치를 검색하는 중…",
  "hi": "आपका स्थान खोजा जा रहा है…"
 },
 "Mencukur (halq) atau memendekkan (taqsir) rambut untuk keluar dari ihram — umrah pun sempurna.": {
  "en": "Shaving (halq) or shortening (taqsir) the hair to exit the state of ihram — and the umrah is complete.",
  "ar": "حلق الرأس (حلق) أو تقصير الشعر (تقصير) للتحلل من الإحرام — وبذلك تكتمل العمرة.",
  "fr": "Se raser (halq) ou raccourcir (taqsir) les cheveux pour sortir de l'état d'ihram — et la omra est accomplie.",
  "de": "Das Rasieren (Halq) oder Kürzen (Taqsir) der Haare zum Austritt aus dem Ihram-Zustand — und die Umrah ist vollständig.",
  "es": "Afeitarse (halq) o acortarse (taqsir) el cabello para salir del estado de ihram — y la umrah queda completada.",
  "ru": "Бритьё головы (халк) или укорачивание (такси́р) волос для выхода из состояния ихрама — и умра завершена.",
  "zh": "剃发（halq）或剪短（taqsir）头发以解除戒衣状态——至此，副朝圆满完成。",
  "ja": "イフラームの状態から出るために髪を剃る（ハルク）または短くする（タクスィール）― これにてウムラが完了します。",
  "ko": "이흐람 상태에서 벗어나기 위해 머리를 삭발(halq)하거나 짧게 자르는(taqsir) 것 — 이로써 우므라가 완성됩니다.",
  "hi": "इहराम की अवस्था से बाहर निकलने के लिए बाल मुंडवाना (हल्क) या छोटा करना (तक़सीर) — और उमरह पूर्ण हो जाती है।"
 },
 "Mendung": {
  "en": "Cloudy",
  "ar": "غائم",
  "fr": "Nuageux",
  "de": "Bewölkt",
  "es": "Nublado",
  "ru": "Облачно",
  "zh": "多云",
  "ja": "曇り",
  "ko": "흐림",
  "hi": "बादल छाए हुए"
 },
 "Mengelilingi Ka'bah tujuh kali dimulai dari Hajar Aswad, lalu salat dua rakaat di Maqam Ibrahim.": {
  "en": "Circumambulating the Ka'bah seven times starting from the Hajar Aswad, then performing two rak'ahs of prayer at Maqam Ibrahim.",
  "ar": "الطواف حول الكعبة سبعة أشواط بدءاً من الحجر الأسود، ثم أداء ركعتين عند مقام إبراهيم.",
  "fr": "Effectuer le tawaf autour de la Ka'bah sept fois en commençant par la Hajar Aswad, puis accomplir deux rak'ahs de prière au Maqam Ibrahim.",
  "de": "Die Ka'bah siebenmal umrunden, beginnend am Hajar Aswad, dann zwei Rak'ahs am Maqam Ibrahim verrichten.",
  "es": "Circunvalar la Ka'bah siete veces comenzando desde la Hajar Aswad, luego realizar dos rak'ahs de oración en el Maqam Ibrahim.",
  "ru": "Совершить таваф вокруг Каабы семь кругов, начиная с Хаджар аль-Асвад, затем совершить два раката намаза у Макам Ибрагим.",
  "zh": "从黑石开始绕天房（卡尔白）七圈，然后在易卜拉欣站台处礼两拜。",
  "ja": "ハジャル・アスワドから始めてカアバを七周し、その後マカーム・イブラーヒームで二ラクアの礼拝を行う。",
  "ko": "하자룰 아스와드에서 시작하여 카아바를 일곱 바퀴 돌고, 그 후 마캄 이브라힘에서 두 라크아의 예배를 드린다.",
  "hi": "हजर-ए-अस्वद से शुरू करके काबा का सात बार तवाफ करें, फिर मकाम इब्राहीम पर दो रकात नमाज़ अदा करें।"
 },
 "Menghadap Kiblat ✓": {
  "en": "Facing the Qiblah ✓",
  "ar": "مستقبلاً القبلة ✓",
  "fr": "Face à la Qiblah ✓",
  "de": "In Richtung der Qiblah ✓",
  "es": "De cara a la Qiblah ✓",
  "ru": "Лицом к Кибле ✓",
  "zh": "面向克尔白 ✓",
  "ja": "キブラの方向を向く ✓",
  "ko": "키블라 방향으로 향함 ✓",
  "hi": "क़िब्ले की ओर मुख करना ✓"
 },
 "Menjamak Maghrib & Isya, bermalam di bawah langit, dan mengumpulkan kerikil untuk melontar jumrah.": {
  "en": "Combining Maghrib & Isha prayers, spending the night under the open sky, and collecting pebbles for throwing at the Jumrah.",
  "ar": "الجمع بين صلاتي المغرب والعشاء، والمبيت تحت السماء المفتوحة، وجمع الحصى لرمي الجمرات.",
  "fr": "Combinaison des prières du Maghrib et de l'Isha, passer la nuit à la belle étoile, et ramasser des cailloux pour lapider les Jumrah.",
  "de": "Das Zusammenlegen der Maghrib- und Isha-Gebete, die Nacht unter freiem Himmel verbringen und Kieselsteine für das Steinigen der Dschimra sammeln.",
  "es": "Combinar las oraciones del Maghrib e Isha, pasar la noche bajo el cielo abierto y recoger piedrecillas para lanzar a las Jumrah.",
  "ru": "Объединение молитв Магриб и Иша, ночёвка под открытым небом и сбор камешков для бросания в Джамарат.",
  "zh": "合并马格里布与伊沙礼拜，在露天过夜，并收集小石子以投掷贾姆拉。",
  "ja": "マグリブとイシャーの礼拝を合わせて行い、野外で夜を過ごし、ジャムラに投げるための小石を集める。",
  "ko": "마그립과 이샤 예배를 합쳐 드리고, 야외에서 밤을 보내며, 자마라트에 던질 조약돌을 모읍니다.",
  "hi": "मग़रिब और इशा की नमाज़ को जमा करना, खुले आसमान के नीचे रात बिताना, और जमरात पर कंकरियाँ मारने के लिए कंकरी इकट्ठा करना।"
 },
 "Metode": {
  "en": "Method",
  "ar": "الطريقة",
  "fr": "Méthode",
  "de": "Methode",
  "es": "Método",
  "ru": "Метод",
  "zh": "方法",
  "ja": "方法",
  "ko": "방법",
  "hi": "विधि"
 },
 "Mina & Melontar Jumrah": {
  "en": "Mina & Stoning of the Jamarat",
  "ar": "منى ورمي الجمرات",
  "fr": "Mina & Lapidation des Jamarat",
  "de": "Mina & Steinigung der Dschamaraat",
  "es": "Mina & Lapidación de las Jamaraat",
  "ru": "Мина и Побивание Джамарат",
  "zh": "米纳与投掷贾马拉特",
  "ja": "ミナとジャマラートへの投石",
  "ko": "미나와 자마라트 투석",
  "hi": "मिना और जमरात की रमी"
 },
 "Minum 200–250 ml air sekarang, sedikit demi sedikit. Tambahkan kurma atau oralit untuk elektrolit.": {
  "en": "Drink 200–250 ml of water now, little by little. Add dates or oral rehydration solution for electrolytes.",
  "ar": "اشرب 200–250 مل من الماء الآن، شيئًا فشيئًا. أضف التمر أو محلول الإماهة الفموية للحصول على الإلكتروليتات.",
  "fr": "Buvez 200–250 ml d'eau maintenant, peu à peu. Ajoutez des dattes ou une solution de réhydratation orale pour les électrolytes.",
  "de": "Trinken Sie jetzt 200–250 ml Wasser, schluckweise. Fügen Sie Datteln oder eine orale Rehydratationslösung für Elektrolyte hinzu.",
  "es": "Beba 200–250 ml de agua ahora, poco a poco. Añada dátiles o solución de rehidratación oral para los electrolitos.",
  "ru": "Выпейте сейчас 200–250 мл воды, маленькими глотками. Добавьте финики или раствор для пероральной регидратации для восполнения электролитов.",
  "zh": "现在慢慢喝200–250毫升水。可加入椰枣或口服补液盐以补充电解质。",
  "ja": "今すぐ200〜250mlの水を少しずつ飲んでください。電解質補給のためにナツメヤシや経口補水液を加えてください。",
  "ko": "지금 200–250ml의 물을 조금씩 마시세요. 전해질 보충을 위해 대추야자나 경구 수액을 추가하세요.",
  "hi": "अभी 200–250 मिली पानी धीरे-धीरे पिएं। इलेक्ट्रोलाइट्स के लिए खजूर या ओआरएस घोल मिलाएं।"
 },
 "Minum 200–250 ml air setiap 20–30 menit meski tidak haus; tambahkan oralit/kurma untuk elektrolit.": {
  "en": "Drink 200–250 ml of water every 20–30 minutes even if not thirsty; add oral rehydration salts/dates for electrolytes.",
  "ar": "اشرب 200–250 مل من الماء كل 20–30 دقيقة حتى وإن لم تشعر بالعطش؛ وأضف محاليل الإماهة الفموية/التمر لتعويض الأملاح المعدنية.",
  "fr": "Buvez 200–250 ml d'eau toutes les 20–30 minutes même si vous n'avez pas soif ; ajoutez des sels de réhydratation orale/dattes pour les électrolytes.",
  "de": "Trinken Sie alle 20–30 Minuten 200–250 ml Wasser, auch wenn Sie keinen Durst haben; fügen Sie orale Rehydrationssalze/Datteln für Elektrolyte hinzu.",
  "es": "Beba 200–250 ml de agua cada 20–30 minutos aunque no tenga sed; agregue sales de rehidratación oral/dátiles para los electrolitos.",
  "ru": "Пейте 200–250 мл воды каждые 20–30 минут, даже если не испытываете жажды; добавляйте растворы для пероральной регидратации/финики для восполнения электролитов.",
  "zh": "每隔20–30分钟饮用200–250毫升水，即使不感到口渴也要饮用；可添加口服补液盐/椰枣以补充电解质。",
  "ja": "喉が渇いていなくても20〜30分ごとに200〜250mlの水を飲んでください。電解質補給のために経口補水塩/ナツメヤシを加えてください。",
  "ko": "목이 마르지 않더라도 20~30분마다 200~250ml의 물을 마시십시오. 전해질 보충을 위해 경구 수분 보충제/대추야자를 추가하십시오.",
  "hi": "प्यास न लगने पर भी हर 20–30 मिनट में 200–250 मिली पानी पिएं; इलेक्ट्रोलाइट्स के लिए ORS/खजूर मिलाएं।"
 },
 "Minum minimal 2–3 liter air sehari, sedikit-sedikit tapi sering.": {
  "en": "Drink at least 2–3 liters of water a day, little by little but frequently.",
  "ar": "اشرب ما لا يقل عن 2–3 لترات من الماء يومياً، قليلاً قليلاً لكن بشكل متكرر.",
  "fr": "Buvez au moins 2 à 3 litres d'eau par jour, peu à peu mais fréquemment.",
  "de": "Trinken Sie täglich mindestens 2–3 Liter Wasser, in kleinen Mengen, aber häufig.",
  "es": "Beba al menos 2–3 litros de agua al día, poco a poco pero con frecuencia.",
  "ru": "Пейте не менее 2–3 литров воды в день, понемногу, но часто.",
  "zh": "每天至少饮用2–3升水，少量多次频繁饮用。",
  "ja": "1日に少なくとも2〜3リットルの水を、少しずつこまめに飲んでください。",
  "ko": "하루에 최소 2–3리터의 물을 조금씩 자주 마시세요.",
  "hi": "प्रतिदिन कम से कम 2–3 लीटर पानी पिएं, थोड़ा-थोड़ा करके लेकिन बार-बार।"
 },
 "Miqat & Ihram": {
  "en": "Miqat & Ihram",
  "ar": "الميقات والإحرام",
  "fr": "Miqat & Ihram",
  "de": "Miqat & Ihram",
  "es": "Miqat & Ihram",
  "ru": "Микат и Ихрам",
  "zh": "戒关与戒衣（米卡特与伊赫兰姆）",
  "ja": "ミーカートとイフラーム",
  "ko": "미카트 & 이흐람",
  "hi": "मीकात और इहराम"
 },
 "Mode Simulasi": {
  "en": "Simulation Mode",
  "ar": "وضع المحاكاة",
  "fr": "Mode Simulation",
  "de": "Simulationsmodus",
  "es": "Modo Simulación",
  "ru": "Режим симуляции",
  "zh": "模拟模式",
  "ja": "シミュレーションモード",
  "ko": "시뮬레이션 모드",
  "hi": "सिमुलेशन मोड"
 },
 "Mode puasa aktif — baris Imsak ditampilkan.": {
  "en": "Fasting mode active — the Imsak row is displayed.",
  "ar": "وضع الصيام نشط — يتم عرض صف الإمساك.",
  "fr": "Mode jeûne actif — la ligne Imsak est affichée.",
  "de": "Fastenmodus aktiv — die Imsak-Zeile wird angezeigt.",
  "es": "Modo de ayuno activo — se muestra la fila de Imsak.",
  "ru": "Режим поста активен — отображается строка Имсак.",
  "zh": "封斋模式已激活 — 显示封斋（Imsak）行。",
  "ja": "断食モードが有効です — イムサク（Imsak）の行が表示されます。",
  "ko": "단식 모드 활성화 — 이므삭(Imsak) 행이 표시됩니다.",
  "hi": "उपवास मोड सक्रिय है — इम्साक (Imsak) पंक्ति प्रदर्शित की गई है।"
 },
 "Mode puasa — pengingat Imsak & sahur": {
  "en": "Fasting mode — Imsak & Suhoor reminder",
  "ar": "وضع الصيام — تذكير الإمساك والسحور",
  "fr": "Mode jeûne — rappel de l'Imsak et du Suhoor",
  "de": "Fastenmodus — Imsak- & Suhoor-Erinnerung",
  "es": "Modo ayuno — recordatorio de Imsak y Suhoor",
  "ru": "Режим поста — напоминание об Имсаке и Сухуре",
  "zh": "斋戒模式 — 封斋与苏候尔提醒",
  "ja": "断食モード — イムサクとスフールのリマインダー",
  "ko": "단식 모드 — 이므삭 & 수후르 알림",
  "hi": "रोज़ा मोड — इम्साक और सुहूर रिमाइंडर"
 },
 "Mode simulasi — geser slider atau seret dial untuk memutar HP secara virtual": {
  "en": "Simulation mode — slide the slider or drag the dial to rotate the phone virtually",
  "ar": "وضع المحاكاة — حرّك شريط التمرير أو اسحب القرص لتدوير الهاتف افتراضياً",
  "fr": "Mode simulation — faites glisser le curseur ou faites pivoter le cadran pour faire tourner le téléphone virtuellement",
  "de": "Simulationsmodus — Schieberegler verschieben oder Drehregler ziehen, um das Telefon virtuell zu drehen",
  "es": "Modo de simulación — desliza el control deslizante o arrastra el dial para rotar el teléfono virtualmente",
  "ru": "Режим симуляции — переместите ползунок или перетащите циферблат, чтобы виртуально повернуть телефон",
  "zh": "模拟模式 — 滑动滑块或拖动拨盘以虚拟旋转手机",
  "ja": "シミュレーションモード — スライダーをスライドするかダイヤルをドラッグして、仮想的にスマートフォンを回転させてください",
  "ko": "시뮬레이션 모드 — 슬라이더를 밀거나 다이얼을 드래그하여 가상으로 휴대폰을 회전하세요",
  "hi": "सिमुलेशन मोड — फ़ोन को वर्चुअली घुमाने के लिए स्लाइडर खिसकाएँ या डायल को खींचें"
 },
 "Mulai (tiap {min} mnt)": {
  "en": "Start (every {min} min)",
  "ar": "ابدأ (كل {min} دقيقة)",
  "fr": "Démarrer (toutes les {min} min)",
  "de": "Starten (alle {min} Min.)",
  "es": "Iniciar (cada {min} min)",
  "ru": "Начать (каждые {min} мин)",
  "zh": "开始（每 {min} 分钟）",
  "ja": "開始（{min} 分ごと）",
  "ko": "시작 (매 {min}분)",
  "hi": "शुरू करें (हर {min} मिनट)"
 },
 "Mulai Mode Simulasi": {
  "en": "Start Simulation Mode",
  "ar": "بدء وضع المحاكاة",
  "fr": "Démarrer le Mode Simulation",
  "de": "Simulationsmodus starten",
  "es": "Iniciar Modo de Simulación",
  "ru": "Запустить режим симуляции",
  "zh": "开始模拟模式",
  "ja": "シミュレーションモードを開始",
  "ko": "시뮬레이션 모드 시작",
  "hi": "सिमुलेशन मोड शुरू करें"
 },
 "Notifikasi tidak tersedia — pengingat hanya saat aplikasi terbuka": {
  "en": "Notifications unavailable — reminders only when the app is open",
  "ar": "الإشعارات غير متاحة — التذكيرات فقط عند فتح التطبيق",
  "fr": "Notifications indisponibles — rappels uniquement lorsque l'application est ouverte",
  "de": "Benachrichtigungen nicht verfügbar — Erinnerungen nur wenn die App geöffnet ist",
  "es": "Notificaciones no disponibles — recordatorios solo cuando la aplicación está abierta",
  "ru": "Уведомления недоступны — напоминания только когда приложение открыто",
  "zh": "通知不可用 — 仅在应用程序打开时提醒",
  "ja": "通知は利用できません — アプリが開いているときのみリマインダーが表示されます",
  "ko": "알림을 사용할 수 없습니다 — 앱이 열려 있을 때만 알림 표시",
  "hi": "सूचनाएं उपलब्ध नहीं हैं — केवल ऐप खुला होने पर अनुस्मारक"
 },
 "Otomatis saat sangat panas": {
  "en": "Automatic when it is very hot",
  "ar": "تلقائي عند الحرارة الشديدة",
  "fr": "Automatique quand il fait très chaud",
  "de": "Automatisch bei sehr heißem Wetter",
  "es": "Automático cuando hace mucho calor",
  "ru": "Автоматически при очень сильной жаре",
  "zh": "极热时自动启动",
  "ja": "非常に暑いときに自動",
  "ko": "매우 더울 때 자동",
  "hi": "बहुत गर्मी होने पर स्वचालित"
 },
 "Panas": {
  "en": "Hot",
  "ar": "حار",
  "fr": "Chaud",
  "de": "Heiß",
  "es": "Caliente",
  "ru": "Жарко",
  "zh": "热",
  "ja": "暑い",
  "ko": "덥다",
  "hi": "गर्म"
 },
 "Pandangan 4 Madzhab": {
  "en": "The Views of the 4 Madhabs",
  "ar": "آراء المذاهب الأربعة",
  "fr": "Les Avis des 4 Madhabs",
  "de": "Die Ansichten der 4 Madhabs",
  "es": "Las Opiniones de los 4 Madhabs",
  "ru": "Взгляды 4 Мазхабов",
  "zh": "四大教法学派的观点",
  "ja": "四大マズハブの見解",
  "ko": "4대 마즈합의 견해",
  "hi": "4 मज़हबों के विचार"
 },
 "Panduan Haji Langkah-demi-Langkah (Inggris)": {
  "en": "Step-by-Step Hajj Guide (English)",
  "ar": "دليل الحج خطوة بخطوة (الإنجليزية)",
  "fr": "Guide du Hajj Étape par Étape (Anglais)",
  "de": "Schritt-für-Schritt Hajj-Leitfaden (Englisch)",
  "es": "Guía de Hajj Paso a Paso (Inglés)",
  "ru": "Пошаговое руководство по Хаджу (Английский)",
  "zh": "朝觐逐步指南（英语）",
  "ja": "ハッジ ステップバイステップガイド（英語）",
  "ko": "단계별 하지 가이드 (영어)",
  "hi": "हज चरण-दर-चरण मार्गदर्शिका (अंग्रेज़ी)"
 },
 "Pedoman Ibadah Haji & Umrah — Kemenag RI": {
  "en": "Hajj & Umrah Worship Guide — Ministry of Religious Affairs of the Republic of Indonesia",
  "ar": "دليل أداء فريضة الحج والعمرة — وزارة الشؤون الدينية لجمهورية إندونيسيا",
  "fr": "Guide des rites du Hajj et de la Omra — Ministère des Affaires religieuses de la République d'Indonésie",
  "de": "Leitfaden für Haddsch & Umra — Ministerium für religiöse Angelegenheiten der Republik Indonesien",
  "es": "Guía de adoración del Hajj y la Umrah — Ministerio de Asuntos Religiosos de la República de Indonesia",
  "ru": "Руководство по поклонению Хаджу и Умре — Министерство по делам религий Республики Индонезия",
  "zh": "朝觐与副朝礼拜指南 — 印度尼西亚共和国宗教事务部",
  "ja": "ハッジ・ウムラ礼拝ガイド — インドネシア共和国宗教省",
  "ko": "하지 및 우므라 예배 안내서 — 인도네시아 공화국 종교부",
  "hi": "हज और उमरह इबादत दिशानिर्देश — धार्मिक मामलों का मंत्रालय, इंडोनेशिया गणराज्य"
 },
 "Pengingat hidrasi": {
  "en": "Hydration Reminder",
  "ar": "تذكير بالترطيب",
  "fr": "Rappel d'hydratation",
  "de": "Erinnerung zur Flüssigkeitszufuhr",
  "es": "Recordatorio de hidratación",
  "ru": "Напоминание о гидратации",
  "zh": "补水提醒",
  "ja": "水分補給リマインダー",
  "ko": "수분 보충 알림",
  "hi": "जलयोजन अनुस्मारक"
 },
 "Pengingat minum air": {
  "en": "Drink Water Reminder",
  "ar": "تذكير بشرب الماء",
  "fr": "Rappel de boire de l'eau",
  "de": "Trinkerinnerung für Wasser",
  "es": "Recordatorio para beber agua",
  "ru": "Напоминание о питье воды",
  "zh": "喝水提醒",
  "ja": "水を飲むリマインダー",
  "ko": "물 마시기 알림",
  "hi": "पानी पीने का अनुस्मारक"
 },
 "Pengingat minum aktif tiap {min} menit sampai {time}": {
  "en": "Active drinking reminder every {min} minutes until {time}",
  "ar": "تذكير شرب الماء نشط كل {min} دقيقة حتى {time}",
  "fr": "Rappel de boisson actif toutes les {min} minutes jusqu'à {time}",
  "de": "Aktive Trinkerinnerung alle {min} Minuten bis {time}",
  "es": "Recordatorio de bebida activo cada {min} minutos hasta {time}",
  "ru": "Активное напоминание о питье каждые {min} минут до {time}",
  "zh": "每隔 {min} 分钟的主动饮水提醒，直到 {time}",
  "ja": "{time}まで{min}分ごとの飲水リマインダーが有効です",
  "ko": "{time}까지 {min}분마다 음수 알림 활성화",
  "hi": "{time} तक हर {min} मिनट में सक्रिय पेय पदार्थ अनुस्मारक"
 },
 "Pengumuman suara": {
  "en": "Voice Announcement",
  "ar": "إعلان صوتي",
  "fr": "Annonce vocale",
  "de": "Sprachansage",
  "es": "Anuncio de voz",
  "ru": "Голосовое объявление",
  "zh": "语音公告",
  "ja": "音声アナウンス",
  "ko": "음성 안내",
  "hi": "वॉयस घोषणा"
 },
 "Perjalanan ziarah Tanah Suci": {
  "en": "Journey of Pilgrimage to the Holy Land",
  "ar": "رحلة الزيارة إلى الأراضي المقدسة",
  "fr": "Voyage de pèlerinage vers la Terre Sainte",
  "de": "Pilgerreise ins Heilige Land",
  "es": "Viaje de peregrinación a la Tierra Santa",
  "ru": "Паломническое путешествие на Святую Землю",
  "zh": "圣地朝圣之旅",
  "ja": "聖地への巡礼の旅",
  "ko": "성지 순례 여행",
  "hi": "पवित्र भूमि की तीर्थयात्रा"
 },
 "Peta Offline": {
  "en": "Offline Map",
  "ar": "خريطة غير متصلة",
  "fr": "Carte Hors Ligne",
  "de": "Offline-Karte",
  "es": "Mapa Sin Conexión",
  "ru": "Офлайн-карта",
  "zh": "离线地图",
  "ja": "オフラインマップ",
  "ko": "오프라인 지도",
  "hi": "ऑफ़लाइन मानचित्र"
 },
 "Peta tersimpan untuk offline": {
  "en": "Map saved for offline",
  "ar": "الخريطة محفوظة للاستخدام دون اتصال",
  "fr": "Carte enregistrée pour une utilisation hors ligne",
  "de": "Karte für die Offline-Nutzung gespeichert",
  "es": "Mapa guardado para uso sin conexión",
  "ru": "Карта сохранена для использования офлайн",
  "zh": "地图已保存以供离线使用",
  "ja": "地図がオフライン用に保存されました",
  "ko": "지도가 오프라인용으로 저장되었습니다",
  "hi": "मानचित्र ऑफ़लाइन उपयोग के लिए सहेजा गया"
 },
 "Pop-up saat waktu salat": {
  "en": "Pop-up during prayer time",
  "ar": "نافذة منبثقة عند وقت الصلاة",
  "fr": "Pop-up lors de l'heure de prière",
  "de": "Pop-up zur Gebetszeit",
  "es": "Pop-up durante el tiempo de oración",
  "ru": "Всплывающее окно во время намаза",
  "zh": "礼拜时间弹窗",
  "ja": "礼拝時間のポップアップ",
  "ko": "예배 시간 팝업",
  "hi": "नमाज़ के वक्त पॉप-अप"
 },
 "Progres Ziarah": {
  "en": "Pilgrimage Progress",
  "ar": "تقدم الزيارة",
  "fr": "Progression du Pèlerinage",
  "de": "Ziarah-Fortschritt",
  "es": "Progreso de la Visita",
  "ru": "Прогресс Паломничества",
  "zh": "朝圣进度",
  "ja": "巡礼の進捗",
  "ko": "순례 진행 상황",
  "hi": "तीर्थयात्रा की प्रगति"
 },
 "Puncak panas": {
  "en": "Peak heat",
  "ar": "ذروة الحرارة",
  "fr": "Pic de chaleur",
  "de": "Höchste Hitze",
  "es": "Pico de calor",
  "ru": "Пик жары",
  "zh": "高温顶峰",
  "ja": "猛暑のピーク",
  "ko": "최고 더위",
  "hi": "गर्मी का चरम"
 },
 "Putar": {
  "en": "Rotate",
  "ar": "تدوير",
  "fr": "Rotation",
  "de": "Drehen",
  "es": "Rotar",
  "ru": "Повернуть",
  "zh": "旋转",
  "ja": "回転",
  "ko": "회전",
  "hi": "घुमाएं"
 },
 "Putar adzan": {
  "en": "Play Adhan",
  "ar": "تشغيل الأذان",
  "fr": "Jouer l'appel à la prière (Adhan)",
  "de": "Adhan abspielen",
  "es": "Reproducir el Adhan",
  "ru": "Воспроизвести азан",
  "zh": "播放阿赞",
  "ja": "アザーンを再生する",
  "ko": "아잔 재생",
  "hi": "अज़ान चलाएं"
 },
 "Putar doa": {
  "en": "Rotate prayer",
  "ar": "تدوير الدعاء",
  "fr": "Faire pivoter la prière",
  "de": "Gebet drehen",
  "es": "Rotar oración",
  "ru": "Повернуть молитву",
  "zh": "旋转祈祷",
  "ja": "祈りを回転する",
  "ko": "기도 회전",
  "hi": "दुआ घुमाएं"
 },
 "Putar ke kanan {deg}°": {
  "en": "Turn right {deg}°",
  "ar": "استدر يميناً {deg}°",
  "fr": "Tournez à droite {deg}°",
  "de": "Rechts abbiegen {deg}°",
  "es": "Gire a la derecha {deg}°",
  "ru": "Повернуть направо {deg}°",
  "zh": "向右转 {deg}°",
  "ja": "右に曲がる {deg}°",
  "ko": "우회전 {deg}°",
  "hi": "दाएं मुड़ें {deg}°"
 },
 "Putar ke kiri {deg}°": {
  "en": "Turn left {deg}°",
  "ar": "انعطف يساراً {deg}°",
  "fr": "Tournez à gauche {deg}°",
  "de": "Links abbiegen {deg}°",
  "es": "Gire a la izquierda {deg}°",
  "ru": "Повернуть налево {deg}°",
  "zh": "向左转 {deg}°",
  "ja": "左に曲がる {deg}°",
  "ko": "왼쪽으로 {deg}° 회전",
  "hi": "बाईं ओर मुड़ें {deg}°"
 },
 "Putar kisah": {
  "en": "Spin the story",
  "ar": "أدر القصة",
  "fr": "Tourner l'histoire",
  "de": "Geschichte drehen",
  "es": "Girar la historia",
  "ru": "Прокрутить историю",
  "zh": "旋转故事",
  "ja": "ストーリーを回す",
  "ko": "이야기 돌리기",
  "hi": "कहानी घुमाएं"
 },
 "Ramadan (otomatis)": {
  "en": "Ramadan (automatic)",
  "ar": "رمضان (تلقائي)",
  "fr": "Ramadan (automatique)",
  "de": "Ramadan (automatisch)",
  "es": "Ramadán (automático)",
  "ru": "Рамадан (автоматически)",
  "zh": "斋月（自动）",
  "ja": "ラマダン（自動）",
  "ko": "라마단 (자동)",
  "hi": "रमज़ान (स्वचालित)"
 },
 "Rute Ziarah Efisien": {
  "en": "Efficient Pilgrimage Route",
  "ar": "مسار الزيارة الفعّال",
  "fr": "Itinéraire de Pèlerinage Efficace",
  "de": "Effiziente Pilgerroute",
  "es": "Ruta de Peregrinación Eficiente",
  "ru": "Эффективный маршрут паломничества",
  "zh": "高效朝圣路线",
  "ja": "効率的な巡礼ルート",
  "ko": "효율적인 순례 경로",
  "hi": "कुशल तीर्थयात्रा मार्ग"
 },
 "Rute ke sini": {
  "en": "Route to here",
  "ar": "المسار إلى هنا",
  "fr": "Itinéraire vers ici",
  "de": "Route hierher",
  "es": "Ruta hasta aquí",
  "ru": "Маршрут сюда",
  "zh": "到这里的路线",
  "ja": "ここへのルート",
  "ko": "여기로 가는 경로",
  "hi": "यहाँ का मार्ग"
 },
 "Sa'i antara Safa & Marwah": {
  "en": "Sa'i between Safa & Marwah",
  "ar": "السعي بين الصفا والمروة",
  "fr": "Sa'i entre Safa & Marwah",
  "de": "Sa'i zwischen Safa & Marwah",
  "es": "Sa'i entre Safa & Marwah",
  "ru": "Са'й между Сафой и Марвой",
  "zh": "萨法与麦尔卧之间的萨依",
  "ja": "サファとマルワの間のサイ",
  "ko": "사파와 마르와 사이의 사이",
  "hi": "सफ़ा और मरवा के बीच सई"
 },
 "Safa → Marwah": {
  "en": "Safa → Marwah",
  "ar": "الصفا → المروة",
  "fr": "Safa → Marwah",
  "de": "Safa → Marwah",
  "es": "Safa → Marwah",
  "ru": "Сафа → Марва",
  "zh": "萨法 → 麦尔卧",
  "ja": "サファ → マルワ",
  "ko": "사파 → 마르와",
  "hi": "सफ़ा → मरवा"
 },
 "Sahur {m} mnt sebelum Imsak": {
  "en": "Suhoor {m} min before Imsak",
  "ar": "السحور {m} دقيقة قبل الإمساك",
  "fr": "Sahour {m} min avant l'Imsak",
  "de": "Sahur {m} Min. vor dem Imsak",
  "es": "Suhoor {m} min antes del Imsak",
  "ru": "Сухур за {m} мин до Имсака",
  "zh": "封斋前 {m} 分钟封斋饭",
  "ja": "イムサクの{m}分前のスフール",
  "ko": "이프삭 {m}분 전 사후르",
  "hi": "इम्साक से {m} मिनट पहले सहूर"
 },
 "Salat": {
  "en": "Salat",
  "ar": "الصلاة",
  "fr": "Salat",
  "de": "Salat",
  "es": "Salat",
  "ru": "Салят",
  "zh": "礼拜（萨拉特）",
  "ja": "サラート",
  "ko": "살라트",
  "hi": "सलात"
 },
 "Salat lebih baik daripada tidur — mulailah hari dengan Subuh berjamaah.": {
  "en": "Prayer is better than sleep — start your day with Fajr in congregation.",
  "ar": "الصلاة خير من النوم — ابدأ يومك بصلاة الفجر جماعةً.",
  "fr": "La prière vaut mieux que le sommeil — commencez votre journée par le Fajr en congrégation.",
  "de": "Das Gebet ist besser als der Schlaf — beginnen Sie Ihren Tag mit dem Fajr-Gebet in der Gemeinschaft.",
  "es": "La oración es mejor que el sueño — comience su día con el Fajr en congregación.",
  "ru": "Молитва лучше сна — начните свой день с намаза Фаджр в джамаате.",
  "zh": "礼拜胜于睡眠——以集体晨礼（法吉尔）开启您的一天。",
  "ja": "礼拝は睡眠よりも優れています — ファジュルの集団礼拝で一日を始めましょう。",
  "ko": "예배는 잠보다 낫습니다 — 파즈르 집단 예배로 하루를 시작하세요.",
  "hi": "नमाज़ नींद से बेहतर है — फ़ज्र की जमाअत के साथ अपने दिन की शुरुआत करें।"
 },
 "Salju": {
  "en": "Snow",
  "ar": "ثلج",
  "fr": "Neige",
  "de": "Schnee",
  "es": "Nieve",
  "ru": "Снег",
  "zh": "雪",
  "ja": "雪",
  "ko": "눈",
  "hi": "बर्फ"
 },
 "Sangat panas": {
  "en": "Very hot",
  "ar": "حارٌّ جداً",
  "fr": "Très chaud",
  "de": "Sehr heiß",
  "es": "Muy caliente",
  "ru": "Очень жарко",
  "zh": "非常热",
  "ja": "とても暑い",
  "ko": "매우 덥다",
  "hi": "बहुत गर्म"
 },
 "Segera menghadap kiblat": {
  "en": "Immediately face the qiblah",
  "ar": "استقبل القبلة فوراً",
  "fr": "Faites face immédiatement à la qiblah",
  "de": "Wende dich sofort der Qiblah zu",
  "es": "Dirígete inmediatamente hacia la qiblah",
  "ru": "Немедленно повернитесь лицом к кибле",
  "zh": "立即面向朝拜方向（基卜拉）",
  "ja": "すぐにキブラの方向を向いてください",
  "ko": "즉시 키블라를 향하세요",
  "hi": "तुरंत क़िब्ला की ओर मुँह करें"
 },
 "Selesai": {
  "en": "Done",
  "ar": "تم",
  "fr": "Terminé",
  "de": "Fertig",
  "es": "Listo",
  "ru": "Готово",
  "zh": "完成",
  "ja": "完了",
  "ko": "완료",
  "hi": "पूर्ण"
 },
 "Semua": {
  "en": "All",
  "ar": "الكل",
  "fr": "Tous",
  "de": "Alle",
  "es": "Todos",
  "ru": "Все",
  "zh": "全部",
  "ja": "すべて",
  "ko": "모두",
  "hi": "सभी"
 },
 "Semua kisah siap offline": {
  "en": "All stories are available offline",
  "ar": "جميع القصص متاحة بدون إنترنت",
  "fr": "Toutes les histoires sont disponibles hors ligne",
  "de": "Alle Geschichten sind offline verfügbar",
  "es": "Todas las historias están disponibles sin conexión",
  "ru": "Все истории доступны офлайн",
  "zh": "所有故事均可离线使用",
  "ja": "すべてのストーリーはオフラインで利用できます",
  "ko": "모든 이야기는 오프라인으로 이용 가능합니다",
  "hi": "सभी कहानियाँ ऑफलाइन उपलब्ध हैं"
 },
 "Semua unduhan dihapus": {
  "en": "All downloads have been deleted",
  "ar": "تم حذف جميع التنزيلات",
  "fr": "Tous les téléchargements ont été supprimés",
  "de": "Alle Downloads wurden gelöscht",
  "es": "Todas las descargas han sido eliminadas",
  "ru": "Все загрузки удалены",
  "zh": "所有下载已被删除",
  "ja": "すべてのダウンロードが削除されました",
  "ko": "모든 다운로드가 삭제되었습니다",
  "hi": "सभी डाउनलोड हटा दिए गए हैं"
 },
 "Senin & Kamis": {
  "en": "Monday & Thursday",
  "ar": "الاثنين والخميس",
  "fr": "Lundi & Jeudi",
  "de": "Montag & Donnerstag",
  "es": "Lunes & Jueves",
  "ru": "Понедельник & Четверг",
  "zh": "周一 & 周四",
  "ja": "月曜日 & 木曜日",
  "ko": "월요일 & 목요일",
  "hi": "सोमवार & गुरुवार"
 },
 "Sensor kompas tidak tersedia di perangkat ini. Coba Mode Simulasi untuk berlatih.": {
  "en": "Compass sensor is not available on this device. Try Simulation Mode to practice.",
  "ar": "مستشعر البوصلة غير متوفر في هذا الجهاز. جرّب وضع المحاكاة للتدرب.",
  "fr": "Le capteur de boussole n'est pas disponible sur cet appareil. Essayez le mode simulation pour vous entraîner.",
  "de": "Der Kompasssensor ist auf diesem Gerät nicht verfügbar. Versuchen Sie den Simulationsmodus zum Üben.",
  "es": "El sensor de brújula no está disponible en este dispositivo. Pruebe el modo de simulación para practicar.",
  "ru": "Датчик компаса недоступен на этом устройстве. Попробуйте режим симуляции для практики.",
  "zh": "此设备上没有指南针传感器。请尝试模拟模式进行练习。",
  "ja": "このデバイスにはコンパスセンサーがありません。練習にはシミュレーションモードをお試しください。",
  "ko": "이 기기에는 나침반 센서가 없습니다. 연습을 위해 시뮬레이션 모드를 사용해 보세요.",
  "hi": "इस डिवाइस पर कम्पास सेंसर उपलब्ध नहीं है। अभ्यास के लिए सिमुलेशन मोड आज़माएं।"
 },
 "Setiap hari": {
  "en": "Every day",
  "ar": "كل يوم",
  "fr": "Chaque jour",
  "de": "Jeden Tag",
  "es": "Cada día",
  "ru": "Каждый день",
  "zh": "每天",
  "ja": "毎日",
  "ko": "매일",
  "hi": "हर दिन"
 },
 "Simpan Jurnal": {
  "en": "Save Journal",
  "ar": "حفظ المجلة",
  "fr": "Enregistrer le Journal",
  "de": "Tagebuch Speichern",
  "es": "Guardar Diario",
  "ru": "Сохранить Журнал",
  "zh": "保存日志",
  "ja": "ジャーナルを保存",
  "ko": "저널 저장",
  "hi": "जर्नल सहेजें"
 },
 "Simpan Offline": {
  "en": "Save Offline",
  "ar": "حفظ دون اتصال",
  "fr": "Enregistrer hors ligne",
  "de": "Offline speichern",
  "es": "Guardar sin conexión",
  "ru": "Сохранить офлайн",
  "zh": "离线保存",
  "ja": "オフラインで保存",
  "ko": "오프라인으로 저장",
  "hi": "ऑफलाइन सहेजें"
 },
 "Simulasi Tata Cara Umrah untuk Pemula": {
  "en": "Umrah Procedure Simulation for Beginners",
  "ar": "محاكاة إجراءات العمرة للمبتدئين",
  "fr": "Simulation des Procédures de la Omra pour Débutants",
  "de": "Simulation des Umrah-Verfahrens für Anfänger",
  "es": "Simulación del Procedimiento de la Umrah para Principiantes",
  "ru": "Симуляция порядка выполнения Умры для начинающих",
  "zh": "初学者副朝程序模拟",
  "ja": "初心者のためのウムラ手順シミュレーション",
  "ko": "초보자를 위한 우므라 절차 시뮬레이션",
  "hi": "शुरुआती लोगों के लिए उमरा प्रक्रिया सिमुलेशन"
 },
 "Situs dikunjungi": {
  "en": "Sites visited",
  "ar": "المواقع التي تمت زيارتها",
  "fr": "Sites visités",
  "de": "Besuchte Orte",
  "es": "Sitios visitados",
  "ru": "Посещённые места",
  "zh": "已访问的地点",
  "ja": "訪問したサイト",
  "ko": "방문한 장소",
  "hi": "देखे गए स्थल"
 },
 "Statistik": {
  "en": "Statistics",
  "ar": "إحصائيات",
  "fr": "Statistiques",
  "de": "Statistiken",
  "es": "Estadísticas",
  "ru": "Статистика",
  "zh": "统计",
  "ja": "統計",
  "ko": "통계",
  "hi": "सांख्यिकी"
 },
 "Statistik Ziarah": {
  "en": "Pilgrimage Statistics",
  "ar": "إحصائيات الزيارة",
  "fr": "Statistiques de Pèlerinage",
  "de": "Pilgerfahrt-Statistiken",
  "es": "Estadísticas de Peregrinación",
  "ru": "Статистика Паломничества",
  "zh": "朝圣统计",
  "ja": "巡礼統計",
  "ko": "순례 통계",
  "hi": "तीर्थयात्रा सांख्यिकी"
 },
 "Subuh 20°, Isya 18°, ihtiyat +2 menit, Imsak = Subuh − 10 menit": {
  "en": "Fajr 20°, Isha 18°, ihtiyat +2 minutes, Imsak = Fajr − 10 minutes",
  "ar": "الفجر 20°، العشاء 18°، الاحتياط +2 دقيقة، الإمساك = الفجر − 10 دقائق",
  "fr": "Fajr 20°, Isha 18°, ihtiyat +2 minutes, Imsak = Fajr − 10 minutes",
  "de": "Fajr 20°, Isha 18°, Ihtiyat +2 Minuten, Imsak = Fajr − 10 Minuten",
  "es": "Fajr 20°, Isha 18°, ihtiyat +2 minutos, Imsak = Fajr − 10 minutos",
  "ru": "Фаджр 20°, Иша 18°, ихтият +2 минуты, Имсак = Фаджр − 10 минут",
  "zh": "晨礼（法吉尔）20°，宵礼（伊沙）18°，预留时间 +2 分钟，封斋时间（Imsak）= 晨礼 − 10 分钟",
  "ja": "ファジュル 20°、イシャー 18°、イフティヤート +2 分、イムサク = ファジュル − 10 分",
  "ko": "파즈르 20°, 이샤 18°, 이흐티야트 +2분, 임삭 = 파즈르 − 10분",
  "hi": "फज्र 20°, इशा 18°, इहतियात +2 मिनट, इम्साक = फज्र − 10 मिनट"
 },
 "Sudah Selesai": {
  "en": "Done",
  "ar": "تم الانتهاء",
  "fr": "Terminé",
  "de": "Fertig",
  "es": "Listo",
  "ru": "Готово",
  "zh": "已完成",
  "ja": "完了しました",
  "ko": "완료되었습니다",
  "hi": "हो गया"
 },
 "Sudah minum": {
  "en": "Already drank",
  "ar": "شربت بالفعل",
  "fr": "Déjà bu",
  "de": "Bereits getrunken",
  "es": "Ya bebido",
  "ru": "Уже выпил",
  "zh": "已经喝了",
  "ja": "もう飲みました",
  "ko": "이미 마셨습니다",
  "hi": "पहले ही पी लिया"
 },
 "Tahallul": {
  "en": "Tahallul",
  "ar": "التحلل",
  "fr": "Tahallul",
  "de": "Tahallul",
  "es": "Tahallul",
  "ru": "Тахаллул",
  "zh": "塔哈鲁勒",
  "ja": "タハッルル",
  "ko": "타할룰",
  "hi": "तहल्लुल"
 },
 "Tahallul: Memotong Rambut Menyempurnakan Umrah": {
  "en": "Tahallul: Cutting Hair Completes Umrah",
  "ar": "التحلل: قص الشعر يُتمّ العمرة",
  "fr": "Tahallul : Se couper les cheveux complète la Omra",
  "de": "Tahallul: Haareschneiden vervollständigt die Umrah",
  "es": "Tahallul: Cortarse el cabello completa la Umrah",
  "ru": "Тахаллул: стрижка волос завершает Умру",
  "zh": "解禁礼：剪发完成副朝",
  "ja": "タハッルル：散髪でウムラを完成させる",
  "ko": "타할룰: 머리카락을 자름으로써 우므라를 완성함",
  "hi": "तहल्लुल: बाल काटकर उमरह पूरा करना"
 },
 "Tambah Foto": {
  "en": "Add Photo",
  "ar": "إضافة صورة",
  "fr": "Ajouter une photo",
  "de": "Foto hinzufügen",
  "es": "Agregar foto",
  "ru": "Добавить фото",
  "zh": "添加照片",
  "ja": "写真を追加",
  "ko": "사진 추가",
  "hi": "फ़ोटो जोड़ें"
 },
 "Tandai 'Di luar ruangan' saat keluar agar pengingat berjalan otomatis ketika sangat panas.": {
  "en": "Mark 'Outdoors' when leaving so reminders run automatically when it is very hot.",
  "ar": "ضع علامة 'في الخارج' عند الخروج حتى تعمل التذكيرات تلقائيًا عندما يكون الجو حارًا جدًا.",
  "fr": "Marquez 'En extérieur' en sortant pour que les rappels se déclenchent automatiquement quand il fait très chaud.",
  "de": "Markieren Sie 'Im Freien' beim Verlassen, damit Erinnerungen automatisch ausgelöst werden, wenn es sehr heiß ist.",
  "es": "Marca 'Al aire libre' al salir para que los recordatorios se activen automáticamente cuando haga mucho calor.",
  "ru": "Отметьте 'На улице' при выходе, чтобы напоминания срабатывали автоматически в сильную жару.",
  "zh": "外出时标记\"户外\"，以便在非常炎热时自动运行提醒。",
  "ja": "外出時に「屋外」をマークすると、非常に暑いときにリマインダーが自動的に作動します。",
  "ko": "매우 더울 때 알림이 자동으로 실행되도록 외출 시 '실외'를 표시하세요.",
  "hi": "बाहर जाते समय 'बाहरी' को चिह्नित करें ताकि बहुत गर्मी होने पर अनुस्मारक स्वचालित रूप से चले।"
 },
 "Tandai Dikunjungi": {
  "en": "Mark as Visited",
  "ar": "وضع علامة كمزار",
  "fr": "Marquer comme Visité",
  "de": "Als Besucht Markieren",
  "es": "Marcar como Visitado",
  "ru": "Отметить как Посещённое",
  "zh": "标记为已访问",
  "ja": "訪問済みとしてマーク",
  "ko": "방문한 것으로 표시",
  "hi": "विज़िट किया हुआ चिह्नित करें"
 },
 "Tandai Selesai": {
  "en": "Mark as Done",
  "ar": "وضع علامة مكتمل",
  "fr": "Marquer comme terminé",
  "de": "Als erledigt markieren",
  "es": "Marcar como hecho",
  "ru": "Отметить как выполненное",
  "zh": "标记为已完成",
  "ja": "完了としてマーク",
  "ko": "완료로 표시",
  "hi": "पूर्ण के रूप में चिह्नित करें"
 },
 "Tandai sudah dipelajari": {
  "en": "Mark as learned",
  "ar": "وضع علامة تم تعلمه",
  "fr": "Marquer comme appris",
  "de": "Als gelernt markieren",
  "es": "Marcar como aprendido",
  "ru": "Отметить как изученное",
  "zh": "标记为已学习",
  "ja": "学習済みとしてマークする",
  "ko": "학습 완료로 표시",
  "hi": "सीखा हुआ चिह्नित करें"
 },
 "Tanggal": {
  "en": "Date",
  "ar": "التاريخ",
  "fr": "Date",
  "de": "Datum",
  "es": "Fecha",
  "ru": "Дата",
  "zh": "日期",
  "ja": "日付",
  "ko": "날짜",
  "hi": "तारीख"
 },
 "Targetkan 3–4 liter air sehari; bawa botol dan isi ulang dari keran zamzam.": {
  "en": "Aim for 3–4 liters of water per day; bring a bottle and refill it from the Zamzam tap.",
  "ar": "استهدف شرب 3–4 لترات من الماء يومياً؛ أحضر زجاجة وأعد ملأها من صنبور زمزم.",
  "fr": "Visez 3 à 4 litres d'eau par jour ; apportez une bouteille et remplissez-la au robinet de Zamzam.",
  "de": "Trinken Sie täglich 3–4 Liter Wasser; bringen Sie eine Flasche mit und füllen Sie sie am Zamzam-Hahn nach.",
  "es": "Apunte a 3–4 litros de agua al día; lleve una botella y recárguela en el grifo de Zamzam.",
  "ru": "Стремитесь выпивать 3–4 литра воды в день; возьмите бутылку и наполняйте её из крана Замзам.",
  "zh": "每天目标饮水3–4升；携带水瓶并在渗渗泉水龙头处补充。",
  "ja": "1日3〜4リットルの水分を目標にしてください。ボトルを持参し、ザムザムの蛇口で補充しましょう。",
  "ko": "하루 3~4리터의 물 섭취를 목표로 하세요. 물병을 가져가 잠잠 수도꼭지에서 보충하세요.",
  "hi": "प्रतिदिन 3–4 लीटर पानी पीने का लक्ष्य रखें; एक बोतल साथ लाएं और ज़मज़म के नल से उसे भरते रहें।"
 },
 "Tata Cara Sa'i antara Safa & Marwah": {
  "en": "The Procedure of Sa'i between Safa & Marwah",
  "ar": "كيفية السعي بين الصفا والمروة",
  "fr": "La Procédure du Sa'i entre Safa & Marwah",
  "de": "Die Durchführung des Sa'i zwischen Safa & Marwah",
  "es": "El Procedimiento del Sa'i entre Safa & Marwah",
  "ru": "Порядок Совершения Са'й между Сафой и Марвой",
  "zh": "萨法与麦尔瓦之间的萨伊程序",
  "ja": "サファーとマルワーの間のサアイの作法",
  "ko": "사파와 마르와 사이의 사이 절차",
  "hi": "सफ़ा और मरवा के बीच सई की विधि"
 },
 "Tata Cara Tawaf Mengelilingi Ka'bah": {
  "en": "The Procedure for Tawaf Circumambulating the Ka'bah",
  "ar": "كيفية الطواف حول الكعبة المشرفة",
  "fr": "La Procédure du Tawaf pour Circumambuler la Ka'bah",
  "de": "Die Vorgehensweise des Tawaf beim Umrunden der Ka'bah",
  "es": "El Procedimiento del Tawaf para Circunambular la Ka'bah",
  "ru": "Порядок совершения Таваф вокруг Каабы",
  "zh": "绕天房塔瓦夫的仪式程序",
  "ja": "カアバを周回するタワーフの作法",
  "ko": "카바를 도는 타와프 절차",
  "hi": "काबा की परिक्रमा करने की तवाफ की विधि"
 },
 "Tawaf Ifadah & Menyempurnakan Haji": {
  "en": "Tawaf Ifadah & Completing the Hajj",
  "ar": "طواف الإفاضة وإتمام الحج",
  "fr": "Tawaf Ifadah & Accomplissement du Hajj",
  "de": "Tawaf Ifadah & Vollendung der Hajj",
  "es": "Tawaf Ifadah & Completar el Hajj",
  "ru": "Таваф Ифада и завершение Хаджа",
  "zh": "绕行天房（塔瓦夫·伊法达）与完成朝觐",
  "ja": "タワーフ・イファーダとハッジの完了",
  "ko": "타와프 이파다 & 하지 완성",
  "hi": "तवाफ इफादा और हज पूरा करना"
 },
 "Tawaf Mengelilingi Ka'bah": {
  "en": "Tawaf Circumambulating the Ka'bah",
  "ar": "الطواف حول الكعبة المشرفة",
  "fr": "Tawaf Circumambulation de la Ka'bah",
  "de": "Tawaf Umrundung der Ka'bah",
  "es": "Tawaf Circunvalación de la Ka'bah",
  "ru": "Таваф Обход вокруг Каабы",
  "zh": "绕克尔白行陶瓦夫",
  "ja": "タワーフ カアバを周回すること",
  "ko": "타와프 카바 주위를 도는 의식",
  "hi": "तवाफ़ काबा की परिक्रमा"
 },
 "Terasa": {
  "en": "Felt",
  "ar": "شُعِرَ",
  "fr": "Ressenti",
  "de": "Gefühlt",
  "es": "Sentido",
  "ru": "Ощущается",
  "zh": "感受到",
  "ja": "感じられる",
  "ko": "느껴짐",
  "hi": "महसूस हुआ"
 },
 "Terdekat dari Anda": {
  "en": "Nearest to You",
  "ar": "الأقرب إليك",
  "fr": "Le plus proche de vous",
  "de": "Am nächsten zu Ihnen",
  "es": "El más cercano a usted",
  "ru": "Ближайший к вам",
  "zh": "距您最近",
  "ja": "あなたに最も近い",
  "ko": "당신과 가장 가까운",
  "hi": "आपके सबसे निकट"
 },
 "Tersimpan": {
  "en": "Saved",
  "ar": "محفوظ",
  "fr": "Enregistré",
  "de": "Gespeichert",
  "es": "Guardado",
  "ru": "Сохранено",
  "zh": "已保存",
  "ja": "保存済み",
  "ko": "저장됨",
  "hi": "सहेजा गया"
 },
 "Tidak ada hari puasa dalam setahun ke depan.": {
  "en": "There are no fasting days in the upcoming year.",
  "ar": "لا توجد أيام صيام في العام القادم.",
  "fr": "Il n'y a aucun jour de jeûne dans l'année à venir.",
  "de": "Es gibt keine Fastentage im kommenden Jahr.",
  "es": "No hay días de ayuno en el próximo año.",
  "ru": "В предстоящем году нет дней поста.",
  "zh": "未来一年内没有斋戒日。",
  "ja": "来年の断食日はありません。",
  "ko": "다가오는 한 해 동안 단식일이 없습니다.",
  "hi": "आने वाले वर्ष में कोई उपवास के दिन नहीं हैं।"
 },
 "Tinggalkan kesibukan sejenak, sempurnakan wudhu, dan hadapkan hati kepada Allah.": {
  "en": "Leave your busyness for a moment, perfect your wudhu, and turn your heart to Allah.",
  "ar": "اترك انشغالاتك لحظةً، وأتمّ وضوءك، وأقبل بقلبك إلى الله.",
  "fr": "Laisse tes occupations un instant, perfectionne ton wudhu, et tourne ton cœur vers Allah.",
  "de": "Lass deine Beschäftigungen einen Moment ruhen, vervollständige deine Wudhu und wende dein Herz Allah zu.",
  "es": "Deja tus ocupaciones por un momento, perfecciona tu wudhu y dirige tu corazón hacia Allah.",
  "ru": "Оставь свои дела на мгновение, соверши должным образом омовение и обрати своё сердце к Аллаху.",
  "zh": "暂时放下繁忙，认真完成小净，将心朝向安拉。",
  "ja": "しばらく忙しさを離れ、ウドゥーを完璧に行い、アッラーに心を向けなさい。",
  "ko": "잠시 바쁜 일을 내려놓고, 우두를 완전히 행하며, 알라를 향해 마음을 돌리십시오.",
  "hi": "थोड़ी देर के लिए व्यस्तता छोड़ें, वुज़ू को पूरा करें, और अपने दिल को अल्लाह की ओर मोड़ें।"
 },
 "Tips hidrasi & keselamatan": {
  "en": "Hydration & Safety Tips",
  "ar": "نصائح الترطيب والسلامة",
  "fr": "Conseils d'hydratation et de sécurité",
  "de": "Hydrations- und Sicherheitstipps",
  "es": "Consejos de hidratación y seguridad",
  "ru": "Советы по гидратации и безопасности",
  "zh": "补水与安全提示",
  "ja": "水分補給と安全のヒント",
  "ko": "수분 보충 및 안전 팁",
  "hi": "जलयोजन और सुरक्षा सुझाव"
 },
 "Tulis kesan, doa, atau kenangan Anda di situs ini…": {
  "en": "Write your impression, prayer, or memory at this site…",
  "ar": "اكتب انطباعك أو دعاءك أو ذكراك في هذا المكان…",
  "fr": "Écrivez votre impression, prière ou souvenir sur ce site…",
  "de": "Schreiben Sie Ihren Eindruck, Ihr Gebet oder Ihre Erinnerung an diesem Ort…",
  "es": "Escribe tu impresión, oración o recuerdo en este lugar…",
  "ru": "Напишите ваше впечатление, молитву или воспоминание об этом месте…",
  "zh": "在此地写下您的感受、祈祷或回忆…",
  "ja": "このサイトでの感想、祈り、または思い出を書いてください…",
  "ko": "이 장소에서의 느낌, 기도 또는 추억을 작성하세요…",
  "hi": "इस स्थान पर अपना अनुभव, दुआ या यादें लिखें…"
 },
 "Tunda 10 mnt": {
  "en": "Snooze 10 min",
  "ar": "تأجيل 10 دقائق",
  "fr": "Reporter de 10 min",
  "de": "10 Min. wiederholen",
  "es": "Posponer 10 min",
  "ru": "Отложить на 10 мин",
  "zh": "推迟10分钟",
  "ja": "10分後に再通知",
  "ko": "10분 후 다시 알림",
  "hi": "10 मिनट बाद याद दिलाएं"
 },
 "Tunda tawaf/sa'i dan ziarah luar ruangan antara pukul 11.00–16.00; pilih malam atau setelah Subuh.": {
  "en": "Postpone tawaf/sa'i and outdoor ziyarah between 11:00–16:00; choose the night or after Fajr.",
  "ar": "أجِّل الطواف/السعي والزيارات الخارجية بين الساعة 11:00–16:00؛ اختر الليل أو ما بعد الفجر.",
  "fr": "Reportez le tawaf/sa'i et les visites en plein air entre 11h00 et 16h00 ; choisissez la nuit ou après le Fajr.",
  "de": "Verschieben Sie Tawaf/Sa'i und Außenbesichtigungen zwischen 11:00–16:00 Uhr; wählen Sie die Nacht oder nach dem Fajr.",
  "es": "Posponga el tawaf/sa'i y las visitas al aire libre entre las 11:00 y las 16:00; elija la noche o después del Fajr.",
  "ru": "Откладывайте таваф/са'й и прогулки на открытом воздухе в период с 11:00 до 16:00; выбирайте ночное время или время после Фаджра.",
  "zh": "请避免在11:00至16:00之间进行绕行/奔走及户外探访，选择夜间或晨礼（法吉尔）后进行。",
  "ja": "タワーフ/サイと屋外訪問は11:00〜16:00の間を避け、夜間またはファジュル後を選んでください。",
  "ko": "타와프/사이와 야외 방문은 11:00~16:00 사이를 피하고, 야간 또는 파즈르 이후를 선택하십시오.",
  "hi": "तवाफ/सई और बाहरी ज़ियारत को 11:00–16:00 के बीच स्थगित करें; रात या फ़ज्र के बाद का समय चुनें।"
 },
 "Tutup": {
  "en": "Close",
  "ar": "إغلاق",
  "fr": "Fermer",
  "de": "Schließen",
  "es": "Cerrar",
  "ru": "Закрыть",
  "zh": "关闭",
  "ja": "閉じる",
  "ko": "닫기",
  "hi": "बंद करें"
 },
 "Uji adzan": {
  "en": "Test adhan",
  "ar": "اختبار الأذان",
  "fr": "Test de l'adhan",
  "de": "Adhan-Test",
  "es": "Prueba del adhan",
  "ru": "Тест азана",
  "zh": "宣礼测试",
  "ja": "アザーンテスト",
  "ko": "아잔 테스트",
  "hi": "अज़ान परीक्षण"
 },
 "Uji pop-up": {
  "en": "Pop-up Test",
  "ar": "اختبار النافذة المنبثقة",
  "fr": "Test de pop-up",
  "de": "Pop-up-Test",
  "es": "Prueba de pop-up",
  "ru": "Тест всплывающего окна",
  "zh": "弹窗测试",
  "ja": "ポップアップテスト",
  "ko": "팝업 테스트",
  "hi": "पॉप-अप परीक्षण"
 },
 "Umrah": {
  "en": "Umrah",
  "ar": "العمرة",
  "fr": "Omra",
  "de": "Umrah",
  "es": "Umrah",
  "ru": "Умра",
  "zh": "副朝",
  "ja": "ウムラ",
  "ko": "우므라",
  "hi": "उमरह"
 },
 "Umrah: Ihram, Niat & Talbiyah — Panduan Animasi": {
  "en": "Umrah: Ihram, Intention & Talbiyah — Animated Guide",
  "ar": "العمرة: الإحرام، النية والتلبية — دليل متحرك",
  "fr": "Omra : Ihram, Intention & Talbiyah — Guide Animé",
  "de": "Umrah: Ihram, Niyyah & Talbiyah — Animierter Leitfaden",
  "es": "Umrah: Ihram, Intención & Talbiyah — Guía Animada",
  "ru": "Умра: Ихрам, Намерение и Талбия — Анимированное руководство",
  "zh": "副朝：戒戒衣、意念与应答词——动画指南",
  "ja": "ウムラ：イフラーム、ニーヤとタルビヤ — アニメーションガイド",
  "ko": "우므라: 이흐람, 니야 & 탈비야 — 애니메이션 가이드",
  "hi": "उमरह: इहराम, नियत और तलबियाह — एनिमेटेड गाइड"
 },
 "Unduh Semua Kisah": {
  "en": "Download All Stories",
  "ar": "تنزيل جميع القصص",
  "fr": "Télécharger toutes les histoires",
  "de": "Alle Geschichten herunterladen",
  "es": "Descargar todas las historias",
  "ru": "Скачать все истории",
  "zh": "下载所有故事",
  "ja": "すべてのストーリーをダウンロード",
  "ko": "모든 이야기 다운로드",
  "hi": "सभी कहानियाँ डाउनलोड करें"
 },
 "Unduh lagi": {
  "en": "Download again",
  "ar": "تحميل مرة أخرى",
  "fr": "Télécharger à nouveau",
  "de": "Erneut herunterladen",
  "es": "Descargar de nuevo",
  "ru": "Скачать снова",
  "zh": "重新下载",
  "ja": "再ダウンロード",
  "ko": "다시 다운로드",
  "hi": "फिर से डाउनलोड करें"
 },
 "Unduhan Offline": {
  "en": "Offline Download",
  "ar": "التنزيل دون اتصال",
  "fr": "Téléchargement hors ligne",
  "de": "Offline-Download",
  "es": "Descarga sin conexión",
  "ru": "Загрузка офлайн",
  "zh": "离线下载",
  "ja": "オフラインダウンロード",
  "ko": "오프라인 다운로드",
  "hi": "ऑफलाइन डाउनलोड"
 },
 "Waktu Imsak tiba — berhenti makan dan minum. Subuh pukul {fajr}.": {
  "en": "Imsak time has arrived — stop eating and drinking. Fajr is at {fajr}.",
  "ar": "حان وقت الإمساك — أوقفوا الأكل والشرب. صلاة الفجر في الساعة {fajr}.",
  "fr": "L'heure de l'Imsak est arrivée — cessez de manger et de boire. Le Fajr est à {fajr}.",
  "de": "Die Imsak-Zeit ist gekommen — hört auf zu essen und zu trinken. Fajr ist um {fajr} Uhr.",
  "es": "Ha llegado la hora del Imsak — dejen de comer y beber. El Fajr es a las {fajr}.",
  "ru": "Наступило время Имсак — прекратите есть и пить. Фаджр в {fajr}.",
  "zh": "封斋时间（Imsak）已到——停止饮食。晨礼（Fajr）时间为 {fajr}。",
  "ja": "イムサクの時間になりました — 飲食をやめてください。ファジュルは {fajr} です。",
  "ko": "이ム삭 시간이 되었습니다 — 음식과 음료를 멈추세요. 파즈르는 {fajr}입니다.",
  "hi": "इम्साक का समय आ गया है — खाना-पीना बंद करें। फज्र {fajr} बजे है।"
 },
 "Waktu salat telah tiba": {
  "en": "The time for prayer has come",
  "ar": "حان وقت الصلاة",
  "fr": "L'heure de la prière est arrivée",
  "de": "Die Gebetszeit ist gekommen",
  "es": "Ha llegado el tiempo de la oración",
  "ru": "Наступило время намаза",
  "zh": "礼拜时间已到",
  "ja": "礼拝の時間になりました",
  "ko": "예배 시간이 되었습니다",
  "hi": "नमाज़ का वक्त आ गया है"
 },
 "Waktunya minum air": {
  "en": "It's time to drink water",
  "ar": "حان وقت شرب الماء",
  "fr": "C'est l'heure de boire de l'eau",
  "de": "Es ist Zeit, Wasser zu trinken",
  "es": "Es hora de beber agua",
  "ru": "Время пить воду",
  "zh": "是时候喝水了",
  "ja": "水を飲む時間です",
  "ko": "물 마실 시간입니다",
  "hi": "पानी पीने का समय है"
 },
 "Waktunya sahur": {
  "en": "It's time for Suhoor",
  "ar": "حان وقت السحور",
  "fr": "C'est l'heure du Suhoor",
  "de": "Es ist Zeit für das Suhoor",
  "es": "Es hora del Suhoor",
  "ru": "Время сухура",
  "zh": "封斋前饭时间到了",
  "ja": "スフールの時間です",
  "ko": "수후르 시간입니다",
  "hi": "सहरी का वक्त हो गया है"
 },
 "WhatsApp": {
  "en": "WhatsApp",
  "ar": "واتساب",
  "fr": "WhatsApp",
  "de": "WhatsApp",
  "es": "WhatsApp",
  "ru": "WhatsApp",
  "zh": "WhatsApp",
  "ja": "WhatsApp",
  "ko": "WhatsApp",
  "hi": "WhatsApp"
 },
 "Wukuf di Arafah": {
  "en": "Wuquf at Arafah",
  "ar": "الوقوف بعرفة",
  "fr": "Wuquf à Arafah",
  "de": "Wuquf in Arafah",
  "es": "Wuquf en Arafah",
  "ru": "Вукуф на Арафате",
  "zh": "在阿拉法特山驻立",
  "ja": "アラファトでのウクーフ",
  "ko": "아라파트에서의 우쿠프",
  "hi": "अरफ़ाह में वुक़ूफ़"
 },
 "Wukuf di Arafah — Penjelasan Haji": {
  "en": "Wuquf at Arafah — Explanation of Hajj",
  "ar": "الوقوف بعرفة — شرح الحج",
  "fr": "Wuquf à Arafah — Explication du Hajj",
  "de": "Wuquf in Arafah — Erklärung der Hajj",
  "es": "Wuquf en Arafah — Explicación del Hajj",
  "ru": "Вукуф в Арафате — Объяснение Хаджа",
  "zh": "在阿拉法特站立——朝觐说明",
  "ja": "アラファートでのウクーフ — ハッジの解説",
  "ko": "아라파트에서의 우쿠프 — 하지 설명",
  "hi": "अरफ़ात में वुक़ूफ़ — हज की व्याख्या"
 },
 "Ziarah Selesai": {
  "en": "Ziarah Complete",
  "ar": "انتهت الزيارة",
  "fr": "Visite Terminée",
  "de": "Ziarah Abgeschlossen",
  "es": "Visita Completada",
  "ru": "Зиярат Завершён",
  "zh": "探访完成",
  "ja": "ジヤーラ完了",
  "ko": "지야라 완료",
  "hi": "ज़ियारह पूर्ण"
 },
 "Zona waktu": {
  "en": "Time Zone",
  "ar": "المنطقة الزمنية",
  "fr": "Fuseau horaire",
  "de": "Zeitzone",
  "es": "Zona horaria",
  "ru": "Часовой пояс",
  "zh": "时区",
  "ja": "タイムゾーン",
  "ko": "시간대",
  "hi": "समय क्षेत्र"
 },
 "Zona waktu lokasi {tz} ({offset}) · berbeda dari jam perangkat Anda ({device})": {
  "en": "Location timezone {tz} ({offset}) · differs from your device time ({device})",
  "ar": "المنطقة الزمنية للموقع {tz} ({offset}) · تختلف عن توقيت جهازك ({device})",
  "fr": "Fuseau horaire du lieu {tz} ({offset}) · diffère de l'heure de votre appareil ({device})",
  "de": "Zeitzone des Standorts {tz} ({offset}) · weicht von Ihrer Gerätezeit ab ({device})",
  "es": "Zona horaria de la ubicación {tz} ({offset}) · difiere de la hora de su dispositivo ({device})",
  "ru": "Часовой пояс местоположения {tz} ({offset}) · отличается от времени вашего устройства ({device})",
  "zh": "位置时区 {tz} ({offset}) · 与您的设备时间不同 ({device})",
  "ja": "場所のタイムゾーン {tz} ({offset}) · デバイスの時刻と異なります ({device})",
  "ko": "위치 시간대 {tz} ({offset}) · 기기 시간과 다릅니다 ({device})",
  "hi": "स्थान का समय क्षेत्र {tz} ({offset}) · आपके डिवाइस के समय से भिन्न है ({device})"
 },
 "Zona waktu {tz} ({offset})": {
  "en": "Time zone {tz} ({offset})",
  "ar": "المنطقة الزمنية {tz} ({offset})",
  "fr": "Fuseau horaire {tz} ({offset})",
  "de": "Zeitzone {tz} ({offset})",
  "es": "Zona horaria {tz} ({offset})",
  "ru": "Часовой пояс {tz} ({offset})",
  "zh": "时区 {tz}（{offset}）",
  "ja": "タイムゾーン {tz}（{offset}）",
  "ko": "시간대 {tz} ({offset})",
  "hi": "समय क्षेत्र {tz} ({offset})"
 },
 "lokasi terakhir": {
  "en": "Last location",
  "ar": "الموقع الأخير",
  "fr": "Dernière localisation",
  "de": "Letzter Standort",
  "es": "Última ubicación",
  "ru": "Последнее местоположение",
  "zh": "最后位置",
  "ja": "最後の位置",
  "ko": "마지막 위치",
  "hi": "अंतिम स्थान"
 },
 "minum berikutnya": {
  "en": "next drink",
  "ar": "الشرب التالي",
  "fr": "prochaine boisson",
  "de": "nächstes Getränk",
  "es": "siguiente bebida",
  "ru": "следующий напиток",
  "zh": "下一次饮水",
  "ja": "次の飲み物",
  "ko": "다음 음료",
  "hi": "अगला पेय"
 },
 "otomatis": {
  "en": "automatic",
  "ar": "تلقائي",
  "fr": "automatique",
  "de": "automatisch",
  "es": "automático",
  "ru": "автоматически",
  "zh": "自动",
  "ja": "自動",
  "ko": "자동",
  "hi": "स्वचालित"
 },
 "sampai": {
  "en": "arrived",
  "ar": "وصلنا",
  "fr": "arrivé",
  "de": "angekommen",
  "es": "llegado",
  "ru": "прибыли",
  "zh": "已到达",
  "ja": "到着しました",
  "ko": "도착했습니다",
  "hi": "पहुँच गए"
 },
 "selesai": {
  "en": "Done",
  "ar": "تم",
  "fr": "Terminé",
  "de": "Fertig",
  "es": "Listo",
  "ru": "Готово",
  "zh": "完成",
  "ja": "完了",
  "ko": "완료",
  "hi": "पूर्ण"
 },
 "siang ini terasa {t}°": {
  "en": "It feels {t}° this afternoon",
  "ar": "يبدو أن درجة الحرارة {t}° هذا الظهر",
  "fr": "Il fait {t}° cet après-midi",
  "de": "Heute Nachmittag fühlt es sich wie {t}° an",
  "es": "Esta tarde se siente {t}°",
  "ru": "Сегодня днём ощущается {t}°",
  "zh": "今天下午感觉有{t}°",
  "ja": "今日の午後は{t}°に感じられます",
  "ko": "오늘 오후는 {t}°로 느껴집니다",
  "hi": "आज दोपहर {t}° महसूस हो रहा है"
 },
 "tanpa notifikasi": {
  "en": "without notification",
  "ar": "بدون إشعار",
  "fr": "sans notification",
  "de": "ohne Benachrichtigung",
  "es": "sin notificación",
  "ru": "без уведомления",
  "zh": "无通知",
  "ja": "通知なし",
  "ko": "알림 없음",
  "hi": "बिना सूचना के"
 },
 "{km} km ke Ka'bah": {
  "en": "{km} km to the Ka'bah",
  "ar": "{km} كم إلى الكعبة المشرفة",
  "fr": "{km} km de la Ka'bah",
  "de": "{km} km zur Ka'bah",
  "es": "{km} km a la Ka'bah",
  "ru": "{km} км до Каабы",
  "zh": "距克尔白 {km} 公里",
  "ja": "カアバ神殿まで {km} km",
  "ko": "카아바까지 {km} km",
  "hi": "काबा से {km} किमी"
 },
 "{n} gelas hari ini": {
  "en": "{n} glasses today",
  "ar": "{n} كوب اليوم",
  "fr": "{n} verres aujourd'hui",
  "de": "{n} Gläser heute",
  "es": "{n} vasos hoy",
  "ru": "{n} стаканов сегодня",
  "zh": "今天{n}杯",
  "ja": "今日{n}杯",
  "ko": "오늘 {n}잔",
  "hi": "आज {n} गिलास"
 },
 "{n} gelas hari ini · pengingat tiap {min} mnt sampai {time}": {
  "en": "{n} glasses today · reminder every {min} min until {time}",
  "ar": "{n} كوب اليوم · تذكير كل {min} دقيقة حتى {time}",
  "fr": "{n} verres aujourd'hui · rappel toutes les {min} min jusqu'à {time}",
  "de": "{n} Gläser heute · Erinnerung alle {min} Min bis {time}",
  "es": "{n} vasos hoy · recordatorio cada {min} min hasta {time}",
  "ru": "{n} стаканов сегодня · напоминание каждые {min} мин до {time}",
  "zh": "今天 {n} 杯 · 每 {min} 分钟提醒一次，直到 {time}",
  "ja": "今日 {n} 杯 · {time} まで {min} 分ごとにリマインダー",
  "ko": "오늘 {n} 잔 · {time}까지 {min}분마다 알림",
  "hi": "आज {n} गिलास · {time} तक हर {min} मिनट पर रिमाइंडर"
 },
 "{n} hari · klik Cetak untuk versi A4 yang rapi": {
  "en": "{n} days · click Print for a neat A4 version",
  "ar": "{n} أيام · انقر على طباعة للحصول على نسخة A4 أنيقة",
  "fr": "{n} jours · cliquez sur Imprimer pour une version A4 soignée",
  "de": "{n} Tage · klicken Sie auf Drucken für eine übersichtliche A4-Version",
  "es": "{n} días · haga clic en Imprimir para una versión A4 ordenada",
  "ru": "{n} дней · нажмите «Печать» для аккуратной версии A4",
  "zh": "{n} 天 · 点击打印以获取整洁的A4版本",
  "ja": "{n} 日 · 印刷をクリックしてA4版をきれいに表示",
  "ko": "{n} 일 · 깔끔한 A4 버전을 보려면 인쇄를 클릭하세요",
  "hi": "{n} दिन · साफ़ A4 संस्करण के लिए प्रिंट पर क्लिक करें"
 }
};
